import React, { useEffect, useState, useRef, useMemo, useLayoutEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { createPortal } from 'react-dom';
import './Board.css';
import './LongCashBoard.css';
import './KhachapuriBoard.css'; // только геометрия Хачапури
import { useSound } from './sfx/SoundProvider';
// ⬇️ ДОБАВЬ ЭТУ СТРОКУ (путь поправь под свой)
import longSocket, { ensureLongSocketAuthAndConnect, rememberLongRoom, clearLongRoom } from './khachapuriSocket';








const LONG_BOARD_SKIN_STORAGE_KEY = 'longBoardSkin';
const LONG_BOARD_SKINS = ['classic', 'luxury', 'carbon', 'royal'];

const LONG_BOARD_SKIN_OPTIONS = [
  {
    id: 'classic',
    src: '/img/Board33.png',
    labelKey: 'game.short.classicBoard',
    defaultLabel: 'Классическая',
  },
  {
    id: 'luxury',
    src: '/img/BoardRoyalFire_v2.png',
    labelKey: 'game.short.luxuryBoard',
    defaultLabel: 'Премиальная',
  },
  {
    id: 'carbon',
    src: '/img/BoardCarbon_v1.png',
    labelKey: 'game.short.carbonBoard',
    defaultLabel: 'Чёрный мрамор',
  },
  {
    id: 'royal',
    src: '/img/BoardRoyal_v1.png',
    labelKey: 'game.short.royalBoard',
    defaultLabel: 'Королевская',
  },
];

const readInitialLongBoardSkin = () => {
  if (typeof window === 'undefined') return 'classic';

  const savedSkin = localStorage.getItem(LONG_BOARD_SKIN_STORAGE_KEY);
  return LONG_BOARD_SKINS.includes(savedSkin) ? savedSkin : 'classic';
};

const LongAutoRollIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
    <rect x="4" y="4" width="16" height="16" rx="3" fill="none" stroke="currentColor" strokeWidth="1.8" />
    <circle cx="8" cy="8" r="1.25" fill="currentColor" />
    <circle cx="16" cy="8" r="1.25" fill="currentColor" />
    <circle cx="12" cy="12" r="1.25" fill="currentColor" />
    <circle cx="8" cy="16" r="1.25" fill="currentColor" />
    <circle cx="16" cy="16" r="1.25" fill="currentColor" />
  </svg>
);

const LongAutoMoveIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
    <path d="M5 5.5 11 12 5 18.5" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M12 5.5 18 12 12 18.5" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const LongSettingsIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
    <path
      d="M9.6 3.5h4.8l.7 2.2c.5.2 1 .5 1.5.9l2.2-.5 2.4 4.1-1.6 1.7v1.8l1.6 1.7-2.4 4.1-2.2-.5c-.5.4-1 .7-1.5.9l-.7 2.2H9.6l-.7-2.2c-.5-.2-1-.5-1.5-.9l-2.2.5-2.4-4.1 1.6-1.7v-1.8l-1.6-1.7 2.4-4.1 2.2.5c.5-.4 1-.7 1.5-.9l.7-2.2Z"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.55"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle cx="12" cy="12.8" r="3" fill="none" stroke="currentColor" strokeWidth="1.7" />
  </svg>
);

const LongCheckIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
    <path d="m6.5 12.5 3.5 3.5 7.5-8" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

function calcIsLongMobile() {
  if (typeof window === 'undefined') return false;

  const w = window.innerWidth || 0;

  const coarse = window.matchMedia?.('(pointer: coarse)')?.matches || false;
  const hover  = window.matchMedia?.('(hover: hover)')?.matches || false;

  const touchPoints = navigator.maxTouchPoints || 0;

  const ua = (navigator.userAgent || '').toLowerCase();
  const uaMobile = /android|iphone|ipad|ipod|windows phone|opera mini|iemobile/.test(ua);

  // “настоящий” тач-only
  const touchOnly = coarse && !hover;

  // страховка: если узко и есть признаки тача/мобилки
  const narrowTouch = (w <= 900) && (touchPoints > 0 || uaMobile);

  return touchOnly || narrowTouch;
}


// 🔹 ВЫНЕСЕННЫЙ НАРУЖУ И МЕМOИЗИРОВАННЫЙ АВАТАР
function AvatarInner({
  src,
  srcList = [],
  alt,
  size = 96,
  textFallback = 'BQ',
  className = '',
}) {
  const PLACEHOLDER = '/img/placeholder.png';

  const candidates = React.useMemo(() => {
    const arr = [];
    if (src) arr.push(src);
    for (const x of srcList) if (x) arr.push(x);
    return Array.from(new Set(arr));
  }, [src, srcList]);

  const [idx, setIdx] = React.useState(0);
  const lockedUrlRef = React.useRef(null);

  React.useEffect(() => {
    if (lockedUrlRef.current) return;
    if (idx >= candidates.length) setIdx(0);
  }, [candidates, idx]);

  const tryUrl = candidates[idx];
  const url = lockedUrlRef.current || tryUrl || PLACEHOLDER;

  const handleLoad = (e) => {
    if (!lockedUrlRef.current) {
      lockedUrlRef.current = e.currentTarget.currentSrc || tryUrl || null;
    }
  };

  const handleError = () => {
    if (lockedUrlRef.current) return;
    setIdx((i) => (i + 1 < candidates.length ? i + 1 : i));
  };

  if (!url || url === PLACEHOLDER) {
    return (
      <div
        className={`rail-ava rail-ava--fallback ${className}`}
        style={{ width: size, height: size, display: 'grid', placeItems: 'center' }}
        aria-label={alt}
        role="img"
      >
        {textFallback}
      </div>
    );
  }

  return (
    <img
      className={`rail-ava ${className}`}
      src={url}
      alt={alt}
      width={size}
      height={size}
      style={{ width: size, height: size, objectFit: 'cover' }}
      onLoad={handleLoad}
      onError={handleError}
      decoding="async"
    />
  );
}

// ✅ Оборачиваем в React.memo, чтобы аватар НЕ перерисовывался на каждый тик таймера
const Avatar = React.memo(AvatarInner);

const KhachapuriBoardDisplay = ({
  // ---- Ваши пропсы ----
  longBoardState,
  longOnPointClick,
  longHandleDragOver,
  longHandleDragStart,
  longHandleDrop,
  longFirstRolls,
  longHasRolledDice,
  firstMoveComplete,
  longCurrentTurn,
  longMyColor = 'white', // 'white' или 'black'
  longRolledDice,
  longShowUndoButton,
  longHandleUndoMove,
  longNumberMove,
  longConfirmMove,
  handleLongRollDiceClick,
  longWhiteOffBoard,
  longBlackOffBoard,
  longFirstMoveComplete,
  longLeaveTable,
  isSpectator,
  rolledByPlayer,
  longPlayer1Time,
  longPlayer2Time,
  longGameResult,
  showLongResultModal,
  closeResultModal,
  currentMultiplier,
  lastDoubler,
  proposeDouble,
  username,
  initialBet,
  maxBet,
  isMyTurn,
  doubleProposal,
  respondToDouble,
  cubeOwner,
  betMultiplier,
  canDouble,
  waitingDoubleReply,
  doubleJustTaken,
  isCrawfordGame,
  onSurrenderClick,
  longPlayer1Name,
  longPlayer2Name,
  longPlayer1Avatar, // опционально
  longPlayer2Avatar, // опционально
  longPlayer1Rating,
  longPlayer2Rating,
  longMatchScore,        // [p1,p2] — очки Хачапури
  longTargetPoints,      // общее количество партий
  khachapuriCurrentGame = 1,
  surenderExit,
  onResultClose,
  autoRoll,
  autoConfirm,
  onToggleAutoRoll,
  onToggleAutoConfirm,
  tableId, 
  // ... и т.д.
}) => {
  const { t: translate } = useTranslation();

  // ==================================================================
  // LONG CASH V2 — только UI/адаптив, игровая логика не меняется.
  // ==================================================================
  const [longBoardSkin, setLongBoardSkin] = useState(readInitialLongBoardSkin);
  const [showLongBoardSettings, setShowLongBoardSettings] = useState(false);
  const [longBoardScale, setLongBoardScale] = useState(1);
  const [longV2Viewport, setLongV2Viewport] = useState(() => {
    if (typeof window === 'undefined') {
      return { width: 1366, height: 768, phoneLandscape: false };
    }

    const vv = window.visualViewport;
    const width = Math.round(vv?.width || window.innerWidth || 1366);
    const height = Math.round(vv?.height || window.innerHeight || 768);

    return {
      width,
      height,
      phoneLandscape: width > height && width <= 1100 && height <= 600,
    };
  });

  const longBoardImageSrc =
    longBoardSkin === 'royal'
      ? '/img/BoardRoyal_v1.png'
      : longBoardSkin === 'carbon'
        ? '/img/BoardCarbon_v1.png'
        : longBoardSkin === 'luxury'
          ? '/img/BoardRoyalFire_v2.png'
          : '/img/Board33.png';

  const longBoardImageAlt =
    longBoardSkin === 'royal'
      ? 'Royal long backgammon board'
      : longBoardSkin === 'carbon'
        ? 'Carbon long backgammon board'
        : longBoardSkin === 'luxury'
          ? 'Luxury long backgammon board'
          : 'Long backgammon board';

  const longBoardGhostClass =
    longBoardSkin === 'royal'
      ? ' checker-royal-ghost'
      : longBoardSkin === 'carbon'
        ? ' checker-carbon-ghost'
        : longBoardSkin === 'luxury'
          ? ' checker-luxury-ghost'
          : '';

  const selectLongBoardSkin = React.useCallback((skinId) => {
    if (!LONG_BOARD_SKINS.includes(skinId)) return;
    setLongBoardSkin(skinId);
    setShowLongBoardSettings(false);
  }, []);

  const closeLongBoardSettings = React.useCallback(() => {
    setShowLongBoardSettings(false);
  }, []);

  useEffect(() => {
    if (typeof window === 'undefined') return;

    localStorage.setItem(LONG_BOARD_SKIN_STORAGE_KEY, longBoardSkin);

    [
      '/img/Board33.png',
      '/img/BoardRoyalFire_v2.png',
      '/img/BoardCarbon_v1.png',
      '/img/BoardRoyal_v1.png',
    ].forEach((src) => {
      const image = new Image();
      image.src = src;
    });
  }, [longBoardSkin]);

  useEffect(() => {
    if (!showLongBoardSettings || typeof document === 'undefined') {
      return undefined;
    }

    const previousOverflow = document.body.style.overflow;
    const onKeyDown = (event) => {
      if (event.key === 'Escape') setShowLongBoardSettings(false);
    };

    document.body.style.overflow = 'hidden';
    document.addEventListener('keydown', onKeyDown);

    return () => {
      document.body.style.overflow = previousOverflow;
      document.removeEventListener('keydown', onKeyDown);
    };
  }, [showLongBoardSettings]);

  useLayoutEffect(() => {
    if (typeof window === 'undefined') return undefined;

    let rafId = 0;

    const syncLongCashViewport = () => {
      cancelAnimationFrame(rafId);
      rafId = requestAnimationFrame(() => {
        const vv = window.visualViewport;
        const width = Math.round(vv?.width || window.innerWidth || 1366);
        const height = Math.round(vv?.height || window.innerHeight || 768);
        const phoneLandscape = width > height && width <= 1100 && height <= 600;

        setLongV2Viewport({ width, height, phoneLandscape });

        if (phoneLandscape) {
          setLongBoardScale(1);
          return;
        }

        const isPhone = width <= 767;
        const isDesktop = width > 1200;
        // ПК: как в коротких кеш-нардах — доска использует почти всю
        // доступную высоту окна, а слева остаётся место под HUD игроков.
        // Телефон/планшет не меняем.
        const reservedTopBottom = isPhone ? 162 : isDesktop ? 6 : 142;
        const reservedSides = isDesktop ? 330 : 12;

        const availableWidth = Math.max(width - reservedSides, 320);
        const availableHeight = Math.max(height - reservedTopBottom, 320);

        const scaleX = availableWidth / 1020;
        const scaleY = availableHeight / 760;
        const maxScale = isDesktop ? 1.21 : 1.18;
        const nextScale = Math.min(scaleX, scaleY, maxScale);

        setLongBoardScale(nextScale > 0 ? nextScale : 1);
      });
    };

    syncLongCashViewport();

    window.addEventListener('resize', syncLongCashViewport, { passive: true });
    window.addEventListener('orientationchange', syncLongCashViewport, { passive: true });
    window.visualViewport?.addEventListener('resize', syncLongCashViewport, { passive: true });

    return () => {
      cancelAnimationFrame(rafId);
      window.removeEventListener('resize', syncLongCashViewport);
      window.removeEventListener('orientationchange', syncLongCashViewport);
      window.visualViewport?.removeEventListener('resize', syncLongCashViewport);
    };
  }, []);

  useEffect(() => {
    if (typeof document === 'undefined') return undefined;
    if (showLongResultModal || longGameResult) return undefined;

    const html = document.documentElement;
    const body = document.body;

    html.classList.add('long-cash-v2-page-lock');
    body.classList.add('long-cash-v2-page-lock');

    return () => {
      html.classList.remove('long-cash-v2-page-lock');
      body.classList.remove('long-cash-v2-page-lock');
    };
  }, [showLongResultModal, longGameResult]);


  // ====== SFX ======
  const { play } = useSound();

  const [conn, setConn] = useState({ online: true, reconnecting: false, attempt: 0, reason: null, message: null });
  const [modalAvatars, setModalAvatars] = useState({
    winner: null,
    loser: null,
  });

  const playSfx = (name) => {
    try {
      const p = play?.(name);
      if (p && typeof p.then === 'function') p.catch(() => {});
    } catch (_) {}
  };

  // для «победитель/проигравший»
  const resultSfxPlayedRef = useRef(false);
  const [peerOnline, setPeerOnline] = useState({});
  // для «double/take/pass»
  const prevDoubleOfferRef = useRef(null);
  const prevBetMultRef     = useRef(Number(betMultiplier) || 1);
  const multAtOfferRef     = useRef(null);
  // ===== Мобильное "перетаскивание" пальцем (через pointer events) =====
  const mobileDragRef = useRef(null);

  // Как в коротких: кнопки выполняются на touchend напрямую.
  // Не привязываем action-кнопки к isLongMobile.
  const mobileTapLockRef = useRef(0);
  const cubeTapLockRef = useRef(0);
  const [cubeRequestPending, setCubeRequestPending] = useState(false);

const [mobileGhost, setMobileGhost] = useState(null);
// { fromIndex, checkerIdx, color, x, y }






// 🔒 Глобальный запрет действий для зрителя
const blockIfSpectator = () => {
  return isSpectator === true;
};






const DRAG_THRESHOLD_PX = 6; // порог «движения» пальца

const handleCheckerPointerDown = (e, fromIndex, checkerIdx) => {
   if (isSpectator) return; 
  if (!isLongMobile) return;

  e.preventDefault();
  if (typeof e.stopPropagation === 'function') e.stopPropagation();

  const startX = e.clientX;
  const startY = e.clientY;

  mobileDragRef.current = {
    fromIndex,
    checkerIdx,
    startX,
    startY,
    moved: false,
  };

  // Цвет шашки для фантома
  let color = 'white';
  const stack = Array.isArray(boardForRender?.[fromIndex])
    ? boardForRender[fromIndex]
    : [];
  const checker = stack[checkerIdx];
  if (checker && checker.color) {
    color = String(checker.color).toLowerCase();
  }

  setMobileGhost({
    fromIndex,
    checkerIdx,
    color,
    x: startX,
    y: startY,
  });

  // ВАЖНО:
  // здесь звук НЕ проигрываем.
  // Реальное действие будет обработано на pointerup:
  // тап -> onPointClickSfxGuarded, drag -> longHandleDragStartSfx/longHandleDropSfx.
  // Иначе один обычный тап давал два одинаковых click-звука.

  // фиксируем все дальнейшие move/up на этой шашке
  try {
    e.currentTarget.setPointerCapture?.(e.pointerId);
  } catch (_) {}
};




const handleBoardPointerUp = (e) => {
  if (isSpectator) return;
  if (!isLongMobile) return;

  const drag = mobileDragRef.current;
  if (!drag) return;

  e.preventDefault();
  if (typeof e.stopPropagation === 'function') e.stopPropagation();

  const clientX = e.clientX;
  const clientY = e.clientY;

  let targetEl = null;
  if (
    typeof document !== 'undefined' &&
    clientX != null &&
    clientY != null
  ) {
    targetEl = document.elementFromPoint(clientX, clientY);
  }

  const pointNode =
    targetEl && targetEl.closest
      ? targetEl.closest('[data-point]')
      : null;

  const fromIndex = drag.fromIndex;
  let moveHandled = false;

  // Настоящее перетаскивание на другой пункт.
  if (drag.moved && pointNode) {
    const toIndex = Number(pointNode.getAttribute('data-point'));

    if (!Number.isNaN(toIndex) && toIndex !== fromIndex) {
      const checkerIdx = drag.checkerIdx ?? 0;
      const payload = JSON.stringify({ fromIndex, checkerIdx });

      const dataStore = {
        'text/plain': payload,
        text: payload,
      };

      const fakeEvent = {
        preventDefault: () => {},
        stopPropagation: () => {},
        dataTransfer: {
          setData: (type, value) => {
            dataStore[type] = value;
          },
          getData: (type) => {
            return dataStore[type] || '';
          },
          effectAllowed: 'move',
          dropEffect: 'move',
        },
      };

      console.log('[MOBILE DROP]', {
        from: fromIndex,
        to: toIndex,
      });

      // Ровно ОДИН dragStart + Ровно ОДИН drop.
      longHandleDragStartSfx(fakeEvent, fromIndex, checkerIdx);
      longHandleDropSfx(fakeEvent, toIndex);
      moveHandled = true;
    }
  }

  // Обычный короткий тап по шашке / исходному пункту.
  if (!moveHandled) {
    // fromMobilePointer=true позволяет делать два быстрых РЕАЛЬНЫХ тапа подряд.
    // Блокироваться будет только последующий браузерный synthetic click.
    onPointClickSfxGuarded(fromIndex, { fromMobilePointer: true });
  }

  /*
   * После pointerup браузер обычно генерирует ещё и click.
   * Этот click всплывает до .point-container, где снова стоит onClick.
   * Раньше из-за этого один тап выполнял longOnPointClick ДВАЖДЫ:
   * сначала отсюда, затем из onClick контейнера.
   */
  suppressSyntheticClickUntilRef.current = Date.now() + 450;

  mobileDragRef.current = null;
  setMobileGhost(null);

  try {
    e.currentTarget.releasePointerCapture?.(e.pointerId);
  } catch (_) {}
};




const handleBoardPointerCancel = (e) => {
  if (isSpectator) return;
  if (!isLongMobile) return;


  const drag = mobileDragRef.current;
  if (!drag) return;

  mobileDragRef.current = null;
  setMobileGhost(null);

  try {
    e.currentTarget.releasePointerCapture?.(e.pointerId);
  } catch (_) {}
};




const handleBoardPointerMove = (e) => {
  if (!isLongMobile) return;


  const drag = mobileDragRef.current;
  if (!drag) return;

  e.preventDefault();
  if (typeof e.stopPropagation === 'function') e.stopPropagation();

  const currX = e.clientX;
  const currY = e.clientY;

  // помечаем, что палец сдвинулся (если хочешь — можешь удалить этот блок вообще)
  const dx = currX - drag.startX;
  const dy = currY - drag.startY;
  const distSq = dx * dx + dy * dy;
  if (!drag.moved && distSq > DRAG_THRESHOLD_PX * DRAG_THRESHOLD_PX) {
    drag.moved = true;
  }

  setMobileGhost((ghost) =>
    ghost
      ? { ...ghost, x: currX, y: currY }
      : ghost
  );
};






// ✅ единственный источник правды
const SILENT_OFFLINE_REASONS = new Set([
  'room_closed',
  'game_finished',
  'surrender',
  'left_table',
  'table_closed',
]);

  // «goodluck» после автопервого броска
  const goodluckPlayedRef = useRef(false);
  const gestureHandlerRef = useRef(null);
  const suppressClickUntilRef = useRef(0);
  // Не даём браузерному synthetic click повторно выполнить ход после mobile pointerup.
  // Отдельный ref, чтобы не ломать быстрые реальные последовательные тапы.
  const suppressSyntheticClickUntilRef = useRef(0);
  const SNAP_KEY = useMemo(() => tableId ? `khachapuri:snap:${tableId}` : null, [tableId]);



  // единое место, где чистим всю "память" длинного стола
const clearLongLocals = () => {
  try {
    // чистим привязку к текущему длинному столу (для авто-реjoin'а)
    clearLongRoom();
  } catch (e) {
    console.warn('[long] clearLongRoom error', e);
  }

  try {
    // убираем снапшот доски для этого стола
    if (SNAP_KEY) {
      localStorage.removeItem(SNAP_KEY);
      localStorage.removeItem('currentTableId');
    }
  } catch (e) {
    console.warn('[long] SNAP_KEY remove error', e);
  }

  try {
    // если ты хранишь тип/текущий стол в "current" — тоже очищаем
    localStorage.removeItem('current');
  } catch (e) {
    console.warn('[long] current remove error', e);
  }
};



  // ================================================================
  // MOBILE ACTION BUTTONS — схема SHORT
  // ================================================================
  const runMobileTap = React.useCallback((fn) => (event) => {
    if (event) {
      event.preventDefault?.();
      event.stopPropagation?.();
    }

    mobileDragRef.current = null;
    setMobileGhost(null);

    const now = Date.now();
    if (now - mobileTapLockRef.current < 350) {
      return;
    }

    mobileTapLockRef.current = now;
    fn?.();
  }, []);

  /*
   * ACTION BUTTON POINTER GUARD
   * ------------------------------------------------------------
   * Khachapuri board itself listens to onPointerUp for mobile checker DnD.
   * Short board does not have that board-level pointer-up handler.
   *
   * On a phone, pointerup happens BEFORE touchend. Therefore an action
   * button tap can bubble to the board before runMobileTap receives
   * touchend. We stop only touch/pen pointer events on the button itself.
   *
   * Mouse is deliberately untouched, so desktop keeps normal onClick.
   */
  const stopMobileActionPointer = React.useCallback((event) => {
    const pointerType = event?.pointerType;

    if (pointerType === 'touch' || pointerType === 'pen') {
      event.stopPropagation?.();
    }
  }, []);

  // ==== UI helper обёртки с SFX ====
  const onPointClickSfxGuarded = (realIndex, options = {}) => {
    if (isSpectator) return;

    const fromMobilePointer = options?.fromMobilePointer === true;
    const now = Date.now();

    // После mobile pointerup браузер присылает ещё synthetic click.
    // Его нельзя пропускать до игровой логики, иначе один тап = два хода.
    if (!fromMobilePointer && now <= suppressSyntheticClickUntilRef.current) {
      return;
    }

    // Старый suppressClickUntilRef оставляем только для его исходной задачи:
    // не накладывать click-звук на goodluck.
    if (now > suppressClickUntilRef.current) {
      playSfx('click');
    }

    longOnPointClick?.(realIndex);
  };

  const longHandleDragStartSfx = (e, fromIndex, checkerIdx) => {
    if (isSpectator) return;   // 👈 ЗАПРЕТ

    playSfx('click');
    longHandleDragStart?.(e, fromIndex, checkerIdx);
  };

  const longHandleDropSfx = (e, toIndex) => {
    if (isSpectator) return;   // 👈 ЗАПРЕТ
    playSfx('drop');
    longHandleDrop?.(e, toIndex);
  };

  const longHandleUndoMoveSfx = () => {
    playSfx('cancel');
    longHandleUndoMove?.();
  };

  const longConfirmMoveSfx = () => {
    playSfx('ok');
    longConfirmMove?.();
  };

  const handleLongRollDiceClickSfx = () => {
    playSfx('dice');
    handleLongRollDiceClick?.();
  };

  const onProposeDoubleClick = () => {
    playSfx('double');
    proposeDouble?.();
  };

  useEffect(() => {
    const clearCubePending = () => setCubeRequestPending(false);

    longSocket.on('long_doubleAccepted', clearCubePending);
    longSocket.on('long_doubleNotAllowed', clearCubePending);
    longSocket.on('long_error', clearCubePending);
    longSocket.on('long_game_result', clearCubePending);

    return () => {
      longSocket.off('long_doubleAccepted', clearCubePending);
      longSocket.off('long_doubleNotAllowed', clearCubePending);
      longSocket.off('long_error', clearCubePending);
      longSocket.off('long_game_result', clearCubePending);
    };
  }, []);

  // Пасс/Тейк на локальных кнопках модалки (звук заранее)
  const onTakeClick = () => {
    playSfx('take');
    respondToDouble?.(true);
  };
  const onPassClick = () => {
    playSfx('pass');
    respondToDouble?.(false);
  };




const prevRolledDiceRef   = useRef(null);
const prevBoardHashRef    = useRef('');
const prevTurnRef         = useRef(longCurrentTurn || null);
const oppClickCooldownRef = useRef(0);
const prevFirstRollsRef   = useRef({});

// const [isLongMobile, setIsLongMobile] = useState(false);
const [isLongMobile, setIsLongMobile] = useState(() => calcIsLongMobile());

  

  useEffect(()=>{
    console.log('проверочка',surenderExit);
  },[surenderExit]);

 useEffect(()=>{
    console.log('проверочка123',longNumberMove,longHasRolledDice,doubleProposal,waitingDoubleReply,doubleJustTaken,isSpectator);
  },[longNumberMove,longHasRolledDice,doubleProposal,waitingDoubleReply,doubleJustTaken,isSpectator]);




// === ОПРЕДЕЛЯЕМ МОБИЛЬНЫЙ РЕЖИМ ДЛЯ ДЛИННОЙ ДОСКИ ===
useEffect(() => {
  if (typeof window === 'undefined') return;


  const detectMobile = () => {
  const w = window.innerWidth || 0;
  const h = window.innerHeight || 0;

  const coarse = window.matchMedia?.('(pointer: coarse)')?.matches || false;
  const hover  = window.matchMedia?.('(hover: hover)')?.matches || false;
  const touchPoints = navigator.maxTouchPoints || 0;

  const ua = (navigator.userAgent || '').toLowerCase();
  const uaMobile = /android|iphone|ipad|ipod|windows phone|opera mini|iemobile/.test(ua);

  const touchOnly = coarse && !hover;

  // ВАЖНО: CSS включает phone-landscape вплоть до 1100px.
  // JS обязан признавать тот же реальный телефон мобильным даже если браузер
  // ошибочно сообщает hover:true или pointer:coarse=false.
  const phoneLandscape =
    w > h &&
    w <= 1100 &&
    h <= 600 &&
    (touchPoints > 0 || uaMobile);

  const narrowTouch =
    w <= 900 &&
    (touchPoints > 0 || uaMobile);

  const isMob = touchOnly || phoneLandscape || narrowTouch || uaMobile;

  console.log('[long mobile check]', {
    w,
    h,
    coarse,
    hover,
    touchPoints,
    uaMobile,
    touchOnly,
    phoneLandscape,
    isMob,
  });

  setIsLongMobile(isMob);
};

  // const detectMobile = () => {
  //   const w = window.innerWidth || 0;
  //   const ua = (navigator.userAgent || '').toLowerCase();

  //   // простая проверка на популярные мобильные
  //   const uaMobile = /android|iphone|ipad|ipod|windows phone|opera mini|iemobile/.test(ua);

  //   const isMob = w <= 900 || uaMobile;

  //   console.log('[long mobile check]', { w, uaMobile, isMob });

  //   setIsLongMobile(isMob);
  // };

  // первый запуск сразу
  detectMobile();

  // и реагируем на изменение размера
  window.addEventListener('resize', detectMobile);
  return () => window.removeEventListener('resize', detectMobile);
}, []);



// useEffect(() => {
//     if (typeof window === 'undefined') return;

//     const mq = window.matchMedia('(max-width: 900px)');

//     const apply = (m) => {
//       setIsLongMobile(!!m.matches);
//     };

//     // начальное значение
//     apply(mq);

//     // подписка на изменение ширины
//     const listener = (e) => apply(e);

//     if (mq.addEventListener) {
//       mq.addEventListener('change', listener);
//     } else if (mq.addListener) {
//       mq.addListener(listener);
//     }

//     return () => {
//       if (mq.removeEventListener) {
//         mq.removeEventListener('change', listener);
//       } else if (mq.removeListener) {
//         mq.removeListener(listener);
//       }
//     };
//   }, []);





// сохраняем свежий снимок каждый раз, когда что-то важное меняется
useEffect(() => {
  if (!SNAP_KEY) return;
  const snap = {
    tableId,
    board_state: longBoardState,
    white_off_board: longWhiteOffBoard,
    black_off_board: longBlackOffBoard,
    current_turn: longCurrentTurn,
    rolled: Array.isArray(longRolledDice) ? longRolledDice : [],
    number_move: longNumberMove,
    player1_time_left: longPlayer1Time,
    player2_time_left: longPlayer2Time,
    cube_owner: cubeOwner || null,
    bet_multiplier: Number(betMultiplier) || 1,
    last_doubler: lastDoubler || null,
    p1: longPlayer1Name || null,
    p2: longPlayer2Name || null,
  };
  try { localStorage.setItem(SNAP_KEY, JSON.stringify(snap)); } catch {}
// перечисли всё, что ты хочешь «снапшотить»
}, [
  SNAP_KEY,
  tableId,
  longBoardState,
  longWhiteOffBoard, longBlackOffBoard,
  longCurrentTurn, longRolledDice, longNumberMove,
  longPlayer1Time, longPlayer2Time,
  cubeOwner, betMultiplier, lastDoubler,
  longPlayer1Name, longPlayer2Name,
]);

// читаем кэш (для рендера во время offline)
const [cachedSnap, setCachedSnap] = useState(null);
const [forceSnap, setForceSnap] = useState(false);
useEffect(() => {
  if (!SNAP_KEY) return;
  try {
    const raw = localStorage.getItem(SNAP_KEY);
    setCachedSnap(raw ? JSON.parse(raw) : null);
  } catch { setCachedSnap(null); }
}, [SNAP_KEY]);

// какой board рендерить: «живой» или из кэша
const boardForRender = (conn.online && !forceSnap)
  ? longBoardState
  : (cachedSnap?.board_state ?? longBoardState);

// то же для таймеров (чтобы не прыгали при offline)
const p1TimeForRender = (conn.online && !forceSnap)
  ? longPlayer1Time
  : (cachedSnap?.player1_time_left ?? longPlayer1Time);

const p2TimeForRender = (conn.online && !forceSnap)
  ? longPlayer2Time
  : (cachedSnap?.player2_time_left ?? longPlayer2Time);



  const whiteOffForRender = (conn.online && !forceSnap)
  ? longWhiteOffBoard
  : (cachedSnap?.white_off_board ?? longWhiteOffBoard);

const blackOffForRender = (conn.online && !forceSnap)
  ? longBlackOffBoard
  : (cachedSnap?.black_off_board ?? longBlackOffBoard);

  // uiIndex: 0..23
  const uiToBoardIndex = (uiIndex, perspective = longMyColor || 'white') => {
    const idxAsWhite = (uiIndex <= 11) ? (11 - uiIndex) : (35 - uiIndex);
    return (perspective === 'white') ? idxAsWhite : (23 - idxAsWhite);
  };

  // ✅ Унифицированный сборщик ORIGIN
  const RAW_API =
    (typeof import.meta !== 'undefined' && (import.meta.env?.VITE_API_ORIGIN || import.meta.env?.VITE_API_URL)) ||
    process.env.REACT_APP_API_ORIGIN ||
    process.env.REACT_APP_API_URL ||
    '';

  const PAGE_PROTOCOL = (typeof window !== 'undefined' && window.location?.protocol) || 'http:';
  const PAGE_HOST     = (typeof window !== 'undefined' && window.location?.hostname) || 'localhost';
  const ENV_PORT      =
    (typeof import.meta !== 'undefined' && (import.meta.env?.VITE_API_PORT || import.meta.env?.VITE_PORT)) ||
    process.env.REACT_APP_API_PORT ||
    process.env.REACT_APP_PORT ||
    (typeof window !== 'undefined' && window.location?.port === '3001' ? '5000' : '');

  let API_ORIGIN = '';
  if (/^https?:\/\//i.test(RAW_API)) {
    API_ORIGIN = RAW_API.replace(/\/+$/, '');
  } else if (RAW_API) {
    const hasPort = /:\d+$/.test(RAW_API);
    API_ORIGIN = `${PAGE_PROTOCOL}//${RAW_API}${hasPort ? '' : (ENV_PORT ? `:${ENV_PORT}` : '')}`.replace(/\/+$/, '');
  } else {
    API_ORIGIN = `${PAGE_PROTOCOL}//${PAGE_HOST}${ENV_PORT ? `:${ENV_PORT}` : ''}`.replace(/\/+$/, '');
  }

  const isP1Turn = longCurrentTurn === 'player1';
  const isP2Turn = longCurrentTurn === 'player2';

  // ✅ Нормализатор пути (абс./относит./имя файла)
  // const normalizeAvatarPath = (raw) => {
  //   const s = String(raw || '').replace(/\\/g, '/').trim();
  //   if (!s) return null;
  //   if (/^https?:\/\//i.test(s) || /^data:/i.test(s)) return s;
  //   if (/^\/?uploads\//i.test(s) || /^\/?api\/uploads\//i.test(s)) {
  //     return new URL(`/${s.replace(/^\/+/, '')}`, API_ORIGIN).href;
  //   }
  //   if (/^\/?avatars\//i.test(s)) {
  //     return new URL(`/uploads/${s.replace(/^\/+/, '')}`, API_ORIGIN).href;
  //   }
  //   const filename = s.split('/').pop();
  //   return filename ? new URL(`/uploads/avatars/${filename}`, API_ORIGIN).href : null;
  // };
// ✅ Нормализатор пути (абс./относит./имя файла) — всегда через /api/uploads

// ✅ Кандидаты URL для аватарки: пытаемся несколькими путями
const avatarCandidates = (raw) => {
  const out = [];
  const ORIGIN = API_ORIGIN || (typeof window !== 'undefined' ? window.location.origin : '');

  const add = (u) => {
    if (!u) return;
    out.push(u);
    // абсолютный от API_ORIGIN
    if (ORIGIN && /^\/[^/]/.test(u)) out.push(`${ORIGIN}${u}`);
  };

  const s = String(raw || '').replace(/\\/g, '/').trim();
  if (!s) return out;

  // Абсолютные URL / data:
  if (/^https?:\/\//i.test(s) || /^data:/i.test(s)) {
    add(s);
    return Array.from(new Set(out));
  }

  // убираем ведущие слэши для конструирования вариантов
  const clean = s.replace(/^\/+/, '');
  const filename = clean.split('/').pop();

  // Если уже с /api/uploads или /uploads — пробуем как есть
  if (/^api\/uploads\//i.test(clean)) add('/' + clean);
  if (/^uploads\//i.test(clean))      add('/' + clean);

  // Иногда присылают 'avatars/xxx.png' — это по факту uploads/avatars
  if (/^avatars\//i.test(clean)) {
    add('/uploads/' + clean);
  }

  // Если пришло просто имя — строим стандартные места хранения
  if (filename) {
    add('/api/uploads/avatars/' + filename);
    add('/uploads/avatars/' + filename);
  }

  // На всякий случай — пробуем ровно то, что пришло
  add('/' + clean);

  // Убираем дубли
  return Array.from(new Set(out));
};

// Совместимость со старым кодом: берём первый подходящий путь
const normalizeAvatarPath = (raw) => {
  const list = avatarCandidates(raw);
  return list && list.length ? list[0] : null;
};



// const normalizeAvatarPath = (raw) => {
//   const s = String(raw || '').replace(/\\/g, '/').trim();
//   if (!s) return null;

//   // 1) Абсолютные URL или data:
//   if (/^https?:\/\//i.test(s) || /^data:/i.test(s)) return s;

//   // Базовый префикс API + uploads
//   const API_PREFIX = '/api';
//   const toAbs = (path) => new URL(path, API_ORIGIN).href;

//   // 2) Уже содержит /api/uploads/...
//   if (/^\/?api\/uploads\//i.test(s)) {
//     return toAbs(`/${s.replace(/^\/+/, '')}`);
//   }

//   // 3) Имеем /uploads/..., добавляем /api спереди
//   if (/^\/?uploads\//i.test(s)) {
//     return toAbs(`${API_PREFIX}/${s.replace(/^\/+/, '')}`); // => /api/uploads/...
//   }

//   // 4) Имеем /avatars/... — это на самом деле /api/uploads/avatars/...
//   if (/^\/?avatars\//i.test(s)) {
//     return toAbs(`${API_PREFIX}/uploads/${s.replace(/^\/+/, '')}`); // => /api/uploads/avatars/...
//   }

//   // 5) Голое имя файла (или произвольный относительный путь) — считаем, что это файл аватарки
//   const filename = s.split('/').pop();
//   if (filename) {
//     return toAbs(`${API_PREFIX}/uploads/avatars/${filename}`);
//   }

//   return null;
// };

  // === КЭШ АВАТАРОК (по имени пользователя) ==========================
  const AVA_CACHE_KEY = 'avatarCacheV1';

  const readAvatarCache = () => {
    try { return JSON.parse(localStorage.getItem(AVA_CACHE_KEY) || '{}'); }
    catch { return {}; }
  };
  const writeAvatarCache = (obj) => {
    try { localStorage.setItem(AVA_CACHE_KEY, JSON.stringify(obj)); } catch {}
  };
  const getCachedAvatar = (username) => {
    if (!username) return null;
    const cache = readAvatarCache();
    return cache[username] || null;
  };
  const setCachedAvatar = (username, url) => {
    if (!username || !url) return;
    const cache = readAvatarCache();
    cache[username] = url;
    writeAvatarCache(cache);
  };
  // ===================================================================

  // 🔧 Нормализатор имён (для матчей по нику) — без "??" для совместимости
const normalizeName = (s) => String(s == null ? '' : s).trim().toLowerCase();
// Кто я и кто оппонент в терминах ключей сервера (player1 / player2)
const myPlayerKey  = (longMyColor === 'white') ? 'player1' : 'player2';
const oppPlayerKey = (myPlayerKey === 'player1') ? 'player2' : 'player1';

// Нормализованное имя меня (для сравнения в событиях)
const meNameNorm = normalizeName(username);


  // Аккуратная аватарка с фолбэком "BQ"
// function Avatar({
//   src,
//   srcList = [],
//   alt,
//   size = 96,
//   textFallback = 'BQ',
//   className = '',
// }) {
//   const PLACEHOLDER = '/img/placeholder.png';

//   // Кандидаты без пустых и дублей (без плейсхолдера здесь!)
//   const candidates = React.useMemo(() => {
//     const arr = [];
//     if (src) arr.push(src);
//     for (const x of srcList) if (x) arr.push(x);
//     return Array.from(new Set(arr));
//   }, [src, srcList]);

//   // Индекс текущей попытки (пока не зафиксировали удачный src)
//   const [idx, setIdx] = React.useState(0);

//   // СЮДА «замораживаем» первый успешно загруженный url
//   const lockedUrlRef = React.useRef(null);

//   // Если список кандидатов поменялся, а мы ещё не «зафиксировали» удачный —
//   // аккуратно держим idx в допустимых пределах, но НЕ сбрасываем удачный.
//   React.useEffect(() => {
//     if (lockedUrlRef.current) return; // уже зафиксированы — ничего не меняем
//     if (idx >= candidates.length) setIdx(0);
//   }, [candidates, idx]);

//   const tryUrl = candidates[idx];                 // текущая попытка
//   const url = lockedUrlRef.current || tryUrl || PLACEHOLDER;

//   const handleLoad = (e) => {
//     // как только первый раз загрузилось — фиксируем и больше не прыгаем
//     if (!lockedUrlRef.current) {
//       lockedUrlRef.current = e.currentTarget.currentSrc || tryUrl || null;
//     }
//   };

//   const handleError = () => {
//     // если уже зафиксированы — ничего не делаем (даже если внезапно 404)
//     if (lockedUrlRef.current) return;
//     // иначе идём к следующему кандидату, а если он последний — покажем фолбэк
//     setIdx((i) => (i + 1 < candidates.length ? i + 1 : i));
//   };

//   // Если вообще нет кандидатов и ничего не зафиксировали — рисуем фолбэк без <img>
//   if (!url || url === PLACEHOLDER) {
//     return (
//       <div
//         className={`rail-ava rail-ava--fallback ${className}`}
//         style={{ width: size, height: size, display: 'grid', placeItems: 'center' }}
//         aria-label={alt}
//         role="img"
//       >
//         {textFallback}
//       </div>
//     );
//   }

//   return (
//     <img
//       className={`rail-ava ${className}`}
//       src={url}
//       alt={alt}
//       width={size}
//       height={size}
//       style={{ width: size, height: size, objectFit: 'cover' }}
//       onLoad={handleLoad}
//       onError={handleError}
//       decoding="async"
//     />
//   );
// }




  // function Avatar({ src, alt, size = 96, textFallback = 'BQ', className = '' }) {
  //   const [ok, setOk] = React.useState(Boolean(src));
  //   React.useEffect(() => setOk(Boolean(src)), [src]);

  //   if (ok) {
  //     return (
  //       <img
  //         className={`rail-ava ${className}`}
  //         src={src}
  //         alt={alt}
  //         style={{ width: size, height: size, objectFit: 'cover' }}   // фикс. размеры
  //         onError={() => setOk(false)}
  //       />
  //     );
  //   }
  //   return (
  //     <div
  //       className={`rail-ava rail-ava--fallback ${className}`}
  //       style={{ width: size, height: size, display: 'grid', placeItems: 'center' }}
  //       aria-label={alt}
  //       role="img"
  //     >
  //       {textFallback}
  //     </div>
  //   );
  // }

  // локальный кэш аватарок для рельс
  const [railAvatars, setRailAvatars] = useState({ white: null, black: null });









// гарантируем подключение при маунте
useEffect(() => {
  ensureLongSocketAuthAndConnect();
}, []);

// слушаем события соединения (при размонтировании — отписываемся)
// причины, при которых баннер лучше не показывать



// отправляем heartbeat на сервер, пока мы online
useEffect(() => {
  let tm;
  if (conn.online && tableId && username) {
    const tick = () => {
      try { longSocket.emit('long_ping', { tableId, username }); } catch {}
      tm = setTimeout(tick, 3000);
    };
    tick();
  }
  return () => { if (tm) clearTimeout(tm); };
}, [conn.online, tableId, username]);


useEffect(() => {
  const handler = (e) => {
    const d = e.detail || {};

    if (d.state === 'online') {
      setConn({ online: true, reconnecting: false, attempt: 0, reason: null, message: null });
      if (tableId) {
    const ask = () => {
      try {
        longSocket.emit('long_requestSnapshot', { longTableId: Number(tableId) });
      } catch {}
    };
    setTimeout(ask, 120);
    setTimeout(ask, 800);
    setTimeout(ask, 2000);
  }
    }

if (d.state === 'offline') {
  const silent = SILENT_OFFLINE_REASONS.has(d.reason); // было .includes
  setConn((s) => ({
    ...s,
    online: false,
    reconnecting: silent ? false : true,
    reason: d.reason ?? s.reason,
    message: silent ? null : (d.message ?? s.message), // ⚠️ берём d.message, не теряем текст
  }));
}


    if (d.state === 'reconnecting') {
      setConn((s) => ({
        ...s,
        online: false,
        reconnecting: true,
        attempt: d.attempt ?? (s.attempt + 1),
      }));
    }

    if (d.state === 'error') {
      setConn((s) => ({
        ...s,
        online: false,
        reconnecting: true,
        message: d.message || s.message,
      }));
    }
  };

  window.addEventListener('long-conn', handler);
  return () => window.removeEventListener('long-conn', handler);
}, []);


// запоминаем текущий стол для авто-реjoin-а, и чистим при выходе
useEffect(() => {
  if (!tableId || !username) return;

  // записываем ТОЛЬКО когда игрок УСПЕШНО вошёл за стол
  // а это происходит после ACK от joinLongTable
  // поэтому этот useEffect — НЕ ПРАВИЛЬНОЕ место для rememberLongRoom
}, []);

/* ⬆️ ВСТАВИТЬ */

useEffect(() => {
  if (!longGameResult) return;

  const winner =
    normalizeAvatarPath(longGameResult.winnerAvatar) ||
    (winnerRailKey ? railSrc[winnerRailKey] : null) ||
    getCachedAvatar(longGameResult.winnerUsername);

  const loser =
    normalizeAvatarPath(longGameResult.loserAvatar) ||
    (loserRailKey ? railSrc[loserRailKey] : null) ||
    getCachedAvatar(longGameResult.loserUsername);

  setModalAvatars({
    winner: winner ? normalizeAvatarPath(winner) : null,
    loser: loser ? normalizeAvatarPath(loser) : null,
  });
}, [longGameResult]);













  useEffect(() => {
    if (!longGameResult) return;

    if (longGameResult.winnerUsername && longGameResult.winnerAvatar) {
      setCachedAvatar(longGameResult.winnerUsername, longGameResult.winnerAvatar);
    }
    if (longGameResult.loserUsername && longGameResult.loserAvatar) {
      setCachedAvatar(longGameResult.loserUsername, longGameResult.loserAvatar);
    }

    const wName = longPlayer1Name;
    const bName = longPlayer2Name;

    const next = { white: null, black: null };

    const wCached = wName ? getCachedAvatar(wName) : null;
    const bCached = bName ? getCachedAvatar(bName) : null;

    if (wCached) next.white = wCached;
    if (bCached) next.black = bCached;

    setRailAvatars(prev => ({
      white: next.white ? normalizeAvatarPath(next.white) : prev.white,
      black: next.black ? normalizeAvatarPath(next.black) : prev.black,
    }));
  }, [longGameResult, longPlayer1Name, longPlayer2Name]);

  // какая сторона моя
  const mySide = longMyColor === 'white' ? 'white' : 'black';

  // моя ава из localStorage — только для моей стороны
  const myAvatarSrc = useMemo(() => {
    const fromLS = localStorage.getItem('avatar');
    return normalizeAvatarPath(fromLS);
  }, []); // eslint-disable-line

  // итоговые URL для рельс
  const railSrc = useMemo(() => {
    const propWhite = normalizeAvatarPath(longPlayer1Avatar);
    const propBlack = normalizeAvatarPath(longPlayer2Avatar);
    return {
      white: propWhite || (mySide === 'white' ? myAvatarSrc : null) || railAvatars.white,
      black: propBlack || (mySide === 'black' ? myAvatarSrc : null) || railAvatars.black,
    };
  }, [longPlayer1Avatar, longPlayer2Avatar, railAvatars, mySide, myAvatarSrc]);

  useEffect(() => {
    console.log('[AVA props]', { longPlayer1Avatar, longPlayer2Avatar });
  }, [longPlayer1Avatar, longPlayer2Avatar]);
  useEffect(() => {
    console.log('[AVA railSrc]', railSrc);
  }, [railSrc]);

  useEffect(() => {
    if (!myAvatarSrc) return;
    setRailAvatars(prev => {
      const next = { ...prev };
      if (mySide === 'white' && !longPlayer1Avatar && !next.white) {
        next.white = myAvatarSrc;
      }
      if (mySide === 'black' && !longPlayer2Avatar && !next.black) {
        next.black = myAvatarSrc;
      }
      return next;
    });
  }, [mySide, myAvatarSrc, longPlayer1Avatar, longPlayer2Avatar]);





useEffect(() => {
  const onTableSnap = (snap = {}) => {
    console.log(
      '%c[SNP] получен снап',
      'color: #00ff00',
      snap
    );

    // проверяем стол
    if (Number(snap.tableId) !== Number(tableId)) return;

    // Собираем наш формат снапа (ключи ровно как у твоего локального SNAP'а выше)
    const next = {
      tableId: snap.tableId,
      board_state: snap.board_state,
      white_off_board: snap.white_off_board,
      black_off_board: snap.black_off_board,
      current_turn: snap.current_turn,
      rolled: Array.isArray(snap.rolled) ? snap.rolled : [],
      number_move: snap.number_move,
      player1_time_left: snap.player1_time_left,
      player2_time_left: snap.player2_time_left,
      cube_owner: snap.cube_owner ?? null,
      bet_multiplier: Number(snap.bet_multiplier) || 1,
      last_doubler: snap.last_doubler ?? null,
      p1: snap.p1 ?? null,
      p2: snap.p2 ?? null,
    };

    try {
      localStorage.setItem(SNAP_KEY, JSON.stringify(next));
    } catch {}

    setCachedSnap(next);
    setForceSnap(true);
  };

  longSocket.on('long_tableSnapshot', onTableSnap);

  return () => {
    longSocket.off('long_tableSnapshot', onTableSnap);
  };
}, [SNAP_KEY, tableId]);




useEffect(() => {
  if (!forceSnap) return;
  // Любое изменение «живой» доски считаем приходом актуальных пропсов
  setForceSnap(false);
  // prevBoardHashRef у тебя уже обновляется в другом эффекте — этого достаточно
}, [longBoardState]); // eslint-disable-line



  // --- freeze avatar src for result modal ---
const winnerModalSrcRef = useRef(null);
const loserModalSrcRef  = useRef(null);





  // кто из текущих игроков победил/проиграл (white/black), если имена совпадают
  const winnerRailKey = useMemo(() => {
    if (!longGameResult) return null;
    const w = normalizeName(longGameResult.winnerUsername);
    if (w && w === normalizeName(longPlayer1Name)) return 'white';
    if (w && w === normalizeName(longPlayer2Name)) return 'black';
    return null;
  }, [longGameResult, longPlayer1Name, longPlayer2Name]);

  const loserRailKey = useMemo(() => {
    if (!longGameResult) return null;
    const l = normalizeName(longGameResult.loserUsername);
    if (l && l === normalizeName(longPlayer1Name)) return 'white';
    if (l && l === normalizeName(longPlayer2Name)) return 'black';
    return null;
  }, [longGameResult, longPlayer1Name, longPlayer2Name]);

  // Источник аватарок для модалки: payload → rails → cache → placeholder
  const winnerResolvedAvatar = useMemo(() => {
    if (!longGameResult) return null;
    const fromPayload = normalizeAvatarPath(longGameResult.winnerAvatar);
    if (fromPayload) return fromPayload;
    const fromRails = winnerRailKey ? railSrc[winnerRailKey] : null;
    if (fromRails) return fromRails;
    const fromCache = getCachedAvatar(longGameResult.winnerUsername);
    if (fromCache) return normalizeAvatarPath(fromCache);
    return '/img/placeholder.png';
  }, [longGameResult, winnerRailKey, railSrc]);

  const loserResolvedAvatar = useMemo(() => {
    if (!longGameResult) return null;
    const fromPayload = normalizeAvatarPath(longGameResult.loserAvatar);
    if (fromPayload) return fromPayload;
    const fromRails = loserRailKey ? railSrc[loserRailKey] : null;
    if (fromRails) return fromRails;
    const fromCache = getCachedAvatar(longGameResult.loserUsername);
    if (fromCache) return normalizeAvatarPath(fromCache);
    return '/img/placeholder.png';
  }, [longGameResult, loserRailKey, railSrc]);


  // Если за столом только один игрок — мгновенно подхватить аву
  useEffect(() => {
    const next = {};

    if (!longPlayer1Avatar && longPlayer1Name && longPlayer1Name === username && myAvatarSrc) {
      next.white = myAvatarSrc;
    }
    if (!longPlayer2Avatar && longPlayer2Name && longPlayer2Name === username && myAvatarSrc) {
      next.black = myAvatarSrc;
    }

    if (!next.white && !longPlayer1Avatar && longPlayer1Name) {
      const cached = getCachedAvatar(longPlayer1Name);
      if (cached) next.white = normalizeAvatarPath(cached);
    }
    if (!next.black && !longPlayer2Avatar && longPlayer2Name) {
      const cached = getCachedAvatar(longPlayer2Name);
      if (cached) next.black = normalizeAvatarPath(cached);
    }

    if (next.white || next.black) {
      setRailAvatars(prev => ({
        white: next.white ?? prev.white,
        black: next.black ?? prev.black,
      }));
    }
  }, [
    longPlayer1Name,
    longPlayer2Name,
    longPlayer1Avatar,
    longPlayer2Avatar,
    myAvatarSrc,
    username,
  ]);



useEffect(() => {
  const curr = Array.isArray(longRolledDice) ? longRolledDice.join(',') : '';
  const prev = prevRolledDiceRef.current;

  if (curr && curr !== prev) {
    // если сервер говорит, кто бросил — используем это
    if (rolledByPlayer) {
      if (rolledByPlayer === oppPlayerKey) {
        playSfx('dice');
      }
    } else {
      // иначе ориентируемся по текущему ходу
      if (longCurrentTurn === oppPlayerKey) {
        playSfx('dice');
      }
    }
  }

  prevRolledDiceRef.current = curr || null;
}, [longRolledDice, rolledByPlayer, longCurrentTurn]);



useEffect(() => {
  const p1 = Number.isInteger(longFirstRolls && longFirstRolls.player1Roll) ? longFirstRolls.player1Roll : null;
  const p2 = Number.isInteger(longFirstRolls && longFirstRolls.player2Roll) ? longFirstRolls.player2Roll : null;
  const prev = prevFirstRollsRef.current || {};

  const changed = (p1 !== (prev.p1 || null)) || (p2 !== (prev.p2 || null));
  if (changed && (p1 !== null || p2 !== null)) {
    playSfx('dice');
  }

  prevFirstRollsRef.current = { p1: p1, p2: p2 };
}, [longFirstRolls]);



useEffect(() => {
  const currHash = JSON.stringify(longBoardState || []);
  const prevHash = prevBoardHashRef.current;
  const boardChanged = currHash !== prevHash;

  if (
    boardChanged &&
    !isSpectator &&
    !showLongResultModal &&
    longHasRolledDice &&
    longCurrentTurn === oppPlayerKey
  ) {
    var now = Date.now();
    if ((oppClickCooldownRef.current || 0) < now) {
      playSfx('click');
      setTimeout(function () { playSfx('drop'); }, 90);
      oppClickCooldownRef.current = now + 120; // троттлинг на серию ходов
    }
  }

  prevBoardHashRef.current = currHash;
}, [longBoardState, longHasRolledDice, longCurrentTurn, isSpectator, showLongResultModal]);



useEffect(() => {
  const prev = prevTurnRef.current;
  const curr = longCurrentTurn;

  if (prev && curr && prev !== curr) {
    if (prev === oppPlayerKey && curr === myPlayerKey) {
      playSfx('ok');
    }
  }
  prevTurnRef.current = curr || null;
}, [longCurrentTurn]);




useEffect(() => {
  function onRemoteUndo(e) {
    var by = e && e.detail && e.detail.by;
    var byNorm = normalizeName(by || '');
    if (byNorm && byNorm !== meNameNorm) playSfx('cancel');
  }
  window.addEventListener('long-undo', onRemoteUndo);
  return () => window.removeEventListener('long-undo', onRemoteUndo);
}, [meNameNorm]);



// ✅ Если сервер прислал аватар в пропсах — сразу кладём в кэш и поднимаем на рельсы
useEffect(() => {
  const next = {};

  if (longPlayer1Avatar) {
    const norm = normalizeAvatarPath(longPlayer1Avatar);
    next.white = norm;
    if (longPlayer1Name) setCachedAvatar(longPlayer1Name, longPlayer1Avatar);
  }

  if (longPlayer2Avatar) {
    const norm = normalizeAvatarPath(longPlayer2Avatar);
    next.black = norm;
    if (longPlayer2Name) setCachedAvatar(longPlayer2Name, longPlayer2Avatar);
  }

  if (next.white || next.black) {
    setRailAvatars(prev => ({
      white: next.white ?? prev.white,
      black: next.black ?? prev.black,
    }));
  }
}, [longPlayer1Avatar, longPlayer2Avatar, longPlayer1Name, longPlayer2Name]);








  // Разделяем массив на 2 части
  // const firstBlack = Array.isArray(longBoardState) && longBoardState.length >= 24
  //   ? longBoardState.slice(0, 12)
  //   : [];
  // const secondBlack = Array.isArray(longBoardState) && longBoardState.length >= 24
  //   ? longBoardState.slice(12)
  //   : [];
  // const firstWhite = Array.isArray(longBoardState) && longBoardState.length >= 24
  //   ? longBoardState.slice(12)
  //   : [];
  // const secondWhite = Array.isArray(longBoardState) && longBoardState.length >= 24
  //   ? longBoardState.slice(0, 12).reverse()
  //   : [];

    // Разделяем массив на 2 части (используем boardForRender, а не голые пропсы)
  const firstBlack = Array.isArray(boardForRender) && boardForRender.length >= 24
    ? boardForRender.slice(0, 12)
    : [];
  const secondBlack = Array.isArray(boardForRender) && boardForRender.length >= 24
    ? boardForRender.slice(12)
    : [];
  const firstWhite = Array.isArray(boardForRender) && boardForRender.length >= 24
    ? boardForRender.slice(12)
    : [];
  const secondWhite = Array.isArray(boardForRender) && boardForRender.length >= 24
    ? boardForRender.slice(0, 12).reverse()
    : [];



  // Имя для рельс
  const getDisplayName = (side) => {
    if (side === 'white') {
      return (longMyColor === 'white' && !isSpectator && username)
        ? username
        : (longPlayer1Name && String(longPlayer1Name).trim() ? longPlayer1Name : translate('game.common.waitingPlayer'));
    }
    return (longMyColor === 'black' && !isSpectator && username)
      ? username
      : (longPlayer2Name && String(longPlayer2Name).trim() ? longPlayer2Name : translate('game.common.waitingPlayer'));
  };

  function nearestCubeFace(mult) {
    if (mult <= 1) return 2;
    return 2 ** Math.ceil(Math.log2(Math.min(mult, 64)));
  }

  // Те же PNG-кубы, которые уже используются в коротких нардах.
  const longCubeImageMap = {
    2: '/img/doubling-cube-2-top.png',
    4: '/img/doubling-cube-4-top.png',
    8: '/img/doubling-cube-8-top.png',
    16: '/img/doubling-cube-16-top.png',
    32: '/img/doubling-cube-32-top.png',
    64: '/img/doubling-cube-64-top.png',
  };

  const longCubeFaceForUi = nearestCubeFace(Number(betMultiplier) || 1);
  const longCubeImageSrc =
    longCubeImageMap[longCubeFaceForUi] || longCubeImageMap[2];

  const renderLongCubeImage = () => (
    <>
      <img
        src={longCubeImageSrc}
        alt={`Doubling cube ${longCubeFaceForUi}`}
        draggable="false"
        style={{
          display: 'block',
          width: '100%',
          height: '100%',
          objectFit: 'contain',
          pointerEvents: 'none',
          userSelect: 'none',
          opacity: 1,
          filter: 'none',
        }}
      />

      {isCrawfordGame && (
        <span
          aria-hidden="true"
          style={{
            position: 'absolute',
            left: '50%',
            top: '50%',
            zIndex: 4,
            transform: 'translate(-50%, -50%)',
            minWidth: '58%',
            minHeight: '58%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            boxSizing: 'border-box',
            padding: '1px 3px 2px',
            border: '1px solid rgba(232, 179, 92, 0.92)',
            borderRadius: '3px',
            background:
              'linear-gradient(145deg, #3a2112 0%, #17100b 58%, #0c0907 100%)',
            color: '#f2ce88',
            fontFamily: "Georgia, 'Times New Roman', serif",
            fontSize: 'clamp(15px, 2.1vw, 24px)',
            fontWeight: 700,
            lineHeight: 1,
            letterSpacing: '-0.7px',
            textShadow:
              '0 1px 0 #6c3f18, 0 2px 2px rgba(0, 0, 0, 0.9)',
            boxShadow:
              'inset 0 0 0 1px rgba(255, 218, 145, 0.16)',
            pointerEvents: 'none',
          }}
        >
          Cr
        </span>
      )}
    </>
  );

  const formatSec = (sec) => {
    const m = String(Math.floor(sec / 60)).padStart(2, '0');
    const s = String(sec % 60).padStart(2, '0');
    return `${m}:${s}`;
  };

  function cubePositionClass() {
    if (!cubeOwner)               return 'cube-neutral';
    if (cubeOwner === username)   return 'cube-my-rail';
    return 'cube-opponent-rail';
  }


// Оба ли слота заняты (оба имени непустые)?
const bothPlayersSeated = React.useMemo(() => {
  const p1 = String(longPlayer1Name || '').trim();
  const p2 = String(longPlayer2Name || '').trim();
  return p1.length > 0 && p2.length > 0;
}, [longPlayer1Name, longPlayer2Name]);

// "липкий" флаг начала партии (только когда оба игрока за столом)
const [longStarted, setLongStarted] = React.useState(() => {
  const evidence = Boolean(
    surenderExit ||
    longFirstMoveComplete ||
    longHasRolledDice ||
    (Array.isArray(longRolledDice) && longRolledDice.length > 0) ||
    waitingDoubleReply || doubleProposal || doubleJustTaken
  );
  return bothPlayersSeated && evidence;
});
const longStartedRef = React.useRef(longStarted);

React.useEffect(() => {
  // если оппонента нет — "Сдаться" быть не может → принудительно выключаем
  if (!bothPlayersSeated) {
    if (longStartedRef.current) {
      longStartedRef.current = false;
      setLongStarted(false);
    }
    return;
  }

  // оппонент есть: включаем "старт" при любом признаке начала
  const evidence = Boolean(
    surenderExit ||
    longFirstMoveComplete ||
    longHasRolledDice ||
    (Array.isArray(longRolledDice) && longRolledDice.length > 0) ||
    waitingDoubleReply || doubleProposal || doubleJustTaken
  );

  if (evidence && !longStartedRef.current) {
    longStartedRef.current = true;
    setLongStarted(true);
  }
  // если evidence пропал, но оба на месте — не понижаем (чтобы не мигало)
}, [
  bothPlayersSeated,
  surenderExit,
  longFirstMoveComplete,
  longHasRolledDice,
  longRolledDice,
  waitingDoubleReply,
  doubleProposal,
  doubleJustTaken
]);
 

// Оба ли слота заняты (оба имени непустые)?
// const bothPlayersSeated = React.useMemo(() => {
//   const p1 = String(longPlayer1Name || '').trim();
//   const p2 = String(longPlayer2Name || '').trim();
//   return p1.length > 0 && p2.length > 0;
// }, [longPlayer1Name, longPlayer2Name]);






// Кандидаты для модалки (payload → rails → cache)
const winnerAvatarCandidates = React.useMemo(() => {
  const arr = [];
  arr.push(normalizeAvatarPath(longGameResult?.winnerAvatar));
  if (winnerRailKey) arr.push(railSrc[winnerRailKey]);
  const fromCache = getCachedAvatar(longGameResult?.winnerUsername);
  if (fromCache) arr.push(normalizeAvatarPath(fromCache));
  return arr.filter(Boolean);
}, [longGameResult, winnerRailKey, railSrc]);

const loserAvatarCandidates = React.useMemo(() => {
  const arr = [];
  arr.push(normalizeAvatarPath(longGameResult?.loserAvatar));
  if (loserRailKey) arr.push(railSrc[loserRailKey]);
  const fromCache = getCachedAvatar(longGameResult?.loserUsername);
  if (fromCache) arr.push(normalizeAvatarPath(fromCache));
  return arr.filter(Boolean);
}, [longGameResult, loserRailKey, railSrc]);




// ✅ Кандидаты для рельс (в порядке приоритета)
const whiteAvatarCandidates = React.useMemo(() => {
  const list = [];
  list.push(...avatarCandidates(longPlayer1Avatar));
  if (!isSpectator && longMyColor === 'white') {
    const my = localStorage.getItem('avatar');
    list.push(...avatarCandidates(my));
  }
  list.push(...avatarCandidates(railAvatars.white));
  if (winnerRailKey === 'white') list.push(...avatarCandidates(winnerResolvedAvatar));
  if (loserRailKey  === 'white') list.push(...avatarCandidates(loserResolvedAvatar));
  // выбрасываем плейсхолдеры, оставляем только реальные пути
  return list.filter(Boolean);
}, [
  longPlayer1Avatar, isSpectator, longMyColor,
  railAvatars.white, winnerRailKey, loserRailKey,
  winnerResolvedAvatar, loserResolvedAvatar
]);

const blackAvatarCandidates = React.useMemo(() => {
  const list = [];
  list.push(...avatarCandidates(longPlayer2Avatar));
  if (!isSpectator && longMyColor === 'black') {
    const my = localStorage.getItem('avatar');
    list.push(...avatarCandidates(my));
  }
  list.push(...avatarCandidates(railAvatars.black));
  if (winnerRailKey === 'black') list.push(...avatarCandidates(winnerResolvedAvatar));
  if (loserRailKey  === 'black') list.push(...avatarCandidates(loserResolvedAvatar));
  return list.filter(Boolean);
}, [
  longPlayer2Avatar, isSpectator, longMyColor,
  railAvatars.black, winnerRailKey, loserRailKey,
  winnerResolvedAvatar, loserResolvedAvatar
]);
 
// const whiteAvatarCandidates = React.useMemo(() => {
//   const list = [];
//   // 1) что пришло в пропсах во время игры
//   list.push(normalizeAvatarPath(longPlayer1Avatar));
//   // 2) если это моя сторона — мой аватар из localStorage
//   if (!isSpectator && longMyColor === 'white') list.push(myAvatarSrc);
//   // 3) локальный «рельсовый» кэш (мы его поднимаем из cache/localStorage)
//   list.push(railAvatars.white);
//   // 4) что модалка «знает» о победителе/проигравшем, если это белые
//   if (winnerRailKey === 'white') list.push(winnerResolvedAvatar);
//   if (loserRailKey  === 'white') list.push(loserResolvedAvatar);
//   return list.filter(Boolean);
// }, [
//   longPlayer1Avatar, isSpectator, longMyColor,
//   myAvatarSrc, railAvatars.white,
//   winnerRailKey, loserRailKey, winnerResolvedAvatar, loserResolvedAvatar
// ]);

// const blackAvatarCandidates = React.useMemo(() => {
//   const list = [];
//   list.push(normalizeAvatarPath(longPlayer2Avatar));
//   if (!isSpectator && longMyColor === 'black') list.push(myAvatarSrc);
//   list.push(railAvatars.black);
//   if (winnerRailKey === 'black') list.push(winnerResolvedAvatar);
//   if (loserRailKey  === 'black') list.push(loserResolvedAvatar);
//   return list.filter(Boolean);
// }, [
//   longPlayer2Avatar, isSpectator, longMyColor,
//   myAvatarSrc, railAvatars.black,
//   winnerRailKey, loserRailKey, winnerResolvedAvatar, loserResolvedAvatar
// ]);




  // const showWhiteOff = longWhiteOffBoard.map((_, i) => (
  //   <div key={`w${i}`} className="checker white" />
  // ));

  // const showBlackOff = longBlackOffBoard.map((_, i) => (
  //   <div key={`b${i}`} className="checker black" />
  // ));

    const showWhiteOff = whiteOffForRender.map((_, i) => (
    <div key={`w${i}`} className="checker white" />
  ));

  const showBlackOff = blackOffForRender.map((_, i) => (
    <div key={`b${i}`} className="checker black" />
  ));


  console.log('[C-4] props.longBoardState len=', longBoardState.length);

  // Карты картинок кубиков
  const diceImages = {
    white: { 1: '/img/k1-white-1.png', 2: '/img/k1-white-2.png', 3: '/img/k1-white-3.png', 4: '/img/k1-white-4.png', 5: '/img/k1-white-5.png', 6: '/img/k1-white-6.png' },
    black: { 1: '/img/k1-black-1.png', 2: '/img/k1-black-2.png', 3: '/img/k1-black-3.png', 4: '/img/k1-black-4.png', 5: '/img/k1-black-5.png', 6: '/img/k1-black-6.png' },
  };





useEffect(() => {
  if (showLongResultModal && longGameResult) {
    // берём первый реальный кандидат, если он есть
    const firstWinner =
      winnerAvatarCandidates && winnerAvatarCandidates.length > 0
        ? winnerAvatarCandidates[0]
        : null;

    const firstLoser =
      loserAvatarCandidates && loserAvatarCandidates.length > 0
        ? loserAvatarCandidates[0]
        : null;

    // фиксируем ТОЛЬКО настоящий url, без плейсхолдера
    if (firstWinner && !winnerModalSrcRef.current) {
      winnerModalSrcRef.current = firstWinner;
    }
    if (firstLoser && !loserModalSrcRef.current) {
      loserModalSrcRef.current = firstLoser;
    }
  } else {
    // при закрытии модалки сбрасываем — для следующей игры
    winnerModalSrcRef.current = null;
    loserModalSrcRef.current  = null;
  }
}, [showLongResultModal, longGameResult, winnerAvatarCandidates, loserAvatarCandidates]);


// useEffect(() => {
//   if (showLongResultModal && longGameResult) {
//     // фиксируем ОДИН раз при открытии
//     if (!winnerModalSrcRef.current) {
//       winnerModalSrcRef.current =
//         (winnerAvatarCandidates && winnerAvatarCandidates[0]) || '/img/placeholder.png';
//     }
//     if (!loserModalSrcRef.current) {
//       loserModalSrcRef.current =
//         (loserAvatarCandidates && loserAvatarCandidates[0]) || '/img/placeholder.png';
//     }
//   } else {
//     // сброс при закрытии — чтобы на след. игру переснять
//     winnerModalSrcRef.current = null;
//     loserModalSrcRef.current  = null;
//   }
// }, [showLongResultModal, longGameResult, winnerAvatarCandidates, loserAvatarCandidates]);








// скрываем баннер во время модалки, при наличии результата, а также при сдаче
// const suppressConnBannerByUi = Boolean(showLongResultModal || longGameResult || surenderExit);

// // итоговое правило показа баннера
// const shouldShowConnBanner =
//   !conn.online &&
//   !suppressConnBannerByUi &&
//   !SILENT_OFFLINE_REASONS.has(conn.reason);


// показывать верхний баннер всегда, когда потеряли соединение,
// кроме «тихих» причин типа закрытого стола
// скрываем баннер во время модалки результата / при сдаче
const suppressConnBannerByUi = Boolean(
  showLongResultModal || longGameResult || surenderExit
);

// итоговое правило показа ВЕРХНЕГО баннера
const shouldShowConnBanner =
  !conn.online &&
  !suppressConnBannerByUi &&
  !SILENT_OFFLINE_REASONS.has(conn.reason);

// const shouldShowConnBanner =
//   !conn.online && !SILENT_OFFLINE_REASONS.has(conn.reason);







  const currentBet = (initialBet || 0) * (betMultiplier || 1);
  const isAtCap    = (maxBet > 0) && (currentBet >= maxBet - 1e-9);

  // В матче деньги в UI не умножаем кубом — всегда базовая ставка
  const isMatch = Number(longTargetPoints) > 1;
  const uiMoneyStake = isMatch ? (Number(initialBet) || 0) : currentBet;

  const money = (n) =>
    `$${Number(n).toLocaleString('en-US', { maximumFractionDigits: 2, minimumFractionDigits: 0 })}`;

  /*
   * КУБ: не доверяем одному canDouble из parent как hard-disable.
   * После confirm/reconnect canDouble может отстать на snapshot,
   * хотя кубиков текущего игрока уже реально нет.
   */
  const cubeMyRole = longMyColor === 'white' ? 'player1' : 'player2';
  const cubeMyTurn = longCurrentTurn === cubeMyRole;

  const cubeHasLiveRoll =
    cubeMyTurn &&
    Boolean(longHasRolledDice) &&
    (
      Number(longNumberMove) > 0 ||
      (
        Array.isArray(longRolledDice) &&
        longRolledDice.length >= 2 &&
        (!rolledByPlayer || rolledByPlayer === cubeMyRole)
      )
    );

  const cubeOwnerBlocks =
    cubeOwner !== null &&
    cubeOwner !== undefined &&
    String(cubeOwner) !== '' &&
    String(cubeOwner) !== String(username || '');

  const cubeLastDoublerBlocks =
    Boolean(lastDoubler) &&
    String(lastDoubler) === String(username || '');

  const cubeDisabled =
    isSpectator ||
    !cubeMyTurn ||
    cubeHasLiveRoll ||
    isCrawfordGame ||
    isAtCap ||
    waitingDoubleReply ||
    !!doubleProposal ||
    cubeRequestPending ||
    cubeOwnerBlocks ||
    cubeLastDoublerBlocks;

  const activateDoubleCube = (event) => {
    event?.preventDefault?.();
    event?.stopPropagation?.();

    if (cubeDisabled) {
      console.log('[KHACHAPURI][CUBE] blocked', {
        cubeMyRole,
        longCurrentTurn,
        longHasRolledDice,
        longNumberMove,
        longRolledDice,
        rolledByPlayer,
        cubeOwner,
        lastDoubler,
        isAtCap,
        waitingDoubleReply,
        hasDoubleProposal: !!doubleProposal,
        canDoubleFromParent: canDouble,
      });
      return;
    }

    const now = Date.now();
    if (now - cubeTapLockRef.current < 350) return;
    cubeTapLockRef.current = now;

    setCubeRequestPending(true);
    playSfx('double');

    if (canDouble && typeof proposeDouble === 'function') {
      proposeDouble();
    } else {
      console.warn('[KHACHAPURI][CUBE] parent canDouble stale -> direct emit', {
        tableId,
        username,
      });

      longSocket.emit('long_proposeDouble', {
        tableId: Number(tableId),
        player: username,
      });
    }
  };

  const renderKhachapuriDoublingCube = (mobile) => (
    <button
      type="button"
      className={
        `doubling-cube ${mobile ? 'doubling-cube--mobile' : 'doubling-cube--center'} ` +
        `${cubePositionClass()} ` +
        `${cubeDisabled ? 'disabled' : ''} ` +
        `${isCrawfordGame ? 'crawford' : ''}`
      }
      onClick={activateDoubleCube}
      onPointerDown={stopMobileActionPointer}
      onPointerUp={stopMobileActionPointer}
      onTouchEnd={activateDoubleCube}
      aria-disabled={cubeDisabled}
      title={isCrawfordGame ? translate('game.long.crawfordNoDouble') : ''}
      style={{
        background: 'transparent',
        border: 0,
        boxShadow: 'none',
        padding: 0,
        overflow: 'visible',
        opacity: 1,
        appearance: 'none',
        WebkitAppearance: 'none'
      }}
    >
      {renderLongCubeImage()}
    </button>
  );

  const isSpectatorView = isSpectator === true;

  // const showMyOff = isSpectatorView
  //   ? longWhiteOffBoard.map((_, i) => <div key={`w${i}`} className="checker white" />)
  //   : (longMyColor === 'white'
  //       ? longWhiteOffBoard.map((_, i) => <div key={`w${i}`} className="checker white" />)
  //       : longBlackOffBoard.map((_, i) => <div key={`b${i}`} className="checker black" />));

  // const showOppOff = isSpectatorView
  //   ? longBlackOffBoard.map((_, i) => <div key={`b${i}`} className="checker black" />)
  //   : (longMyColor === 'white'
  //       ? longBlackOffBoard.map((_, i) => <div key={`b${i}`} className="checker black" />)
  //       : longWhiteOffBoard.map((_, i) => <div key={`w${i}`} className="checker white" />));


    const showMyOff = isSpectatorView
    ? whiteOffForRender.map((_, i) => (
        <div key={`w${i}`} className="checker white" />
      ))
    : (longMyColor === 'white'
        ? whiteOffForRender.map((_, i) => (
            <div key={`w${i}`} className="checker white" />
          ))
        : blackOffForRender.map((_, i) => (
            <div key={`b${i}`} className="checker black" />
          )));

  const showOppOff = isSpectatorView
    ? blackOffForRender.map((_, i) => (
        <div key={`b${i}`} className="checker black" />
      ))
    : (longMyColor === 'white'
        ? blackOffForRender.map((_, i) => (
            <div key={`b${i}`} className="checker black" />
          ))
        : whiteOffForRender.map((_, i) => (
            <div key={`w${i}`} className="checker white" />
          )));


  // Модалка удвоения — portal в body, чтобы landscape/transform/z-index
  // доски никогда не могли её обрезать или спрятать.
  function DoublingModal() {
    if (!doubleProposal) return null;

    const cubeValue  = doubleProposal.cubeValue ?? doubleProposal.newMultiplier;
    const targetBet  = doubleProposal.proposedBet;
    const withCap    = typeof targetBet === 'number'
      ? translate('game.long.betUpTo', { amount: targetBet })
      : '';

    const modalNode = (
      <div
        className="double-mask khachapuri-double-mask"
        onPointerDown={(event) => event.stopPropagation()}
        onClick={(event) => event.stopPropagation()}
      >
        <div className="double-dialog khachapuri-double-dialog">
          <p>
            {translate('game.long.player')}{' '}
            <strong>{doubleProposal.by}</strong>{' '}
            {translate('game.long.offersDoubleTo')}
            {cubeValue}
            {withCap}
          </p>

          <div className="btn-row">
            <button
              type="button"
              className="btn-take"
              onClick={onTakeClick}
              onPointerDown={stopMobileActionPointer}
              onPointerUp={stopMobileActionPointer}
              onTouchEnd={runMobileTap(onTakeClick)}
            >
              {translate('game.short.take')}
            </button>

            <button
              type="button"
              className="btn-pass"
              onClick={onPassClick}
              onPointerDown={stopMobileActionPointer}
              onPointerUp={stopMobileActionPointer}
              onTouchEnd={runMobileTap(onPassClick)}
            >
              {translate('game.short.pass')}
            </button>
          </div>
        </div>
      </div>
    );

    return typeof document !== 'undefined'
      ? createPortal(modalNode, document.body)
      : modalNode;
  }


  function renderStackedCheckers(point, { isTopRow, realIndex }) {
  const checkers = Array.isArray(point) ? point : [];
  const visible  = checkers.slice(-5);
  const total    = checkers.length;

  return visible.map((checker, i) => {
    if (!checker || !checker.color) return null;
    const color = String(checker.color).toLowerCase();
    const showCount = total > 5
      ? i === visible.length - 1
      : false;

    return (
      <div
        key={i}
        className={`checker ${color} ${showCount ? 'checker--with-count' : ''}`}
        draggable={!isSpectator && !isLongMobile}
        onDragStart={(e) => longHandleDragStartSfx(e, realIndex, i)}
        onPointerDown={(e) => handleCheckerPointerDown(e, realIndex, i)}
      >
        {showCount && <span className="stack-count">{total}</span>}
      </div>
    );
  });
}

  
 

  // function renderStackedCheckers(point, { isTopRow, realIndex }) {
  //   const checkers = Array.isArray(point) ? point : [];
  //   const visible  = checkers.slice(-5);
  //   const total    = checkers.length;

  //   return visible.map((checker, i) => {
  //     if (!checker || !checker.color) return null;
  //     const color = String(checker.color).toLowerCase();
  //     const showCount = total > 5
  //       ? (isTopRow ? i === visible.length - 1 : i === 0)
  //       : false;

  //     return (
  //       <div
  //         key={i}
  //         className={`checker ${color}`}
  //         draggable={!isSpectator}
  //         onDragStart={(e) => longHandleDragStartSfx(e, realIndex, i)}
  //       >
  //         {showCount && <span className="stack-count">{total}</span>}
  //       </div>
  //     );
  //   });
  // }

  const renderWhiteTopRow = () => (
    <div className="top-row">
      {(firstWhite || []).map((point, idx) => {
        const realIndex = 24 - idx - 1;
        return (
          <div
  key={idx}
  className={`point-container p${idx}`}
  data-point={realIndex}
  onClick={() => onPointClickSfxGuarded(realIndex)}
  onDragOver={longHandleDragOver}
  onDrop={(e) => longHandleDropSfx(e, realIndex)}
>

            <span>{idx + 13}</span>
            {renderStackedCheckers(point, { isTopRow: true, realIndex })}
          </div>
        );
      })}
    </div>
  );

  const renderWhiteBottomRow = () => (
    <div className="bottom-row">
      {(secondWhite || []).map((point, idx) => {
        const realIndex = idx;
        return (
         <div
  key={idx}
  className={`point-containerd r${idx}`}
  data-point={realIndex}
  onClick={() => onPointClickSfxGuarded(realIndex)}
  onDragOver={longHandleDragOver}
  onDrop={(e) => longHandleDropSfx(e, realIndex)}
>

            {renderStackedCheckers(point, { isTopRow: false, realIndex })}
            <span>{12 - idx}</span>
          </div>
        );
      })}
    </div>
  );

  const renderBlackTopRow = () => (
    <div className="top-row">
      {(firstBlack || []).map((point, idx) => {
        const uiIndex = 11 - idx;
        const label   = idx + 13;
        return (
     <div
  key={idx}
  className={`point-container p${idx}`}
  data-point={uiIndex}
  onClick={() => onPointClickSfxGuarded(uiIndex)}
  onDragOver={longHandleDragOver}
  onDrop={(e) => longHandleDropSfx(e, uiIndex)}
>

            <span>{label}</span>
            {renderStackedCheckers(point, { isTopRow: true, realIndex: uiIndex })}
          </div>
        );
      })}
    </div>
  );

  const renderBlackBottomRow = () => {
    const seq = [...secondBlack].reverse();
    return (
      <div className="bottom-row">
        {seq.map((point, idx) => {
          const realIndex = 12 + idx;
          const label = 12 - idx;
          return (
           <div
  key={idx}
  className={`point-containerd r${idx}`}
  data-point={realIndex}
  onClick={() => onPointClickSfxGuarded(realIndex)}
  onDragOver={longHandleDragOver}
  onDrop={(e) => longHandleDropSfx(e, realIndex)}
>

              {renderStackedCheckers(point, { isTopRow: false, realIndex })}
              <span>{label}</span>
            </div>
          );
        })}
      </div>
    );
  };

  // ====== SFX: предложение/принятие/отказ от куба ======
  useEffect(() => {
    const curr = doubleProposal ?? null;
    const prev = prevDoubleOfferRef.current;

    const changed = JSON.stringify(curr) !== JSON.stringify(prev);
    if (curr && changed) {
      multAtOfferRef.current = Number(betMultiplier) || 1;
      playSfx('double');
    }
    prevDoubleOfferRef.current = curr;
  }, [doubleProposal, betMultiplier]); // eslint-disable-line

  useEffect(() => {
    const prev = prevBetMultRef.current;
    const curr = Number(betMultiplier) || 1;
    if (curr > prev) playSfx('take');
    prevBetMultRef.current = curr;
  }, [betMultiplier]); // eslint-disable-line

  useEffect(() => {
    const prev = prevDoubleOfferRef.current;
    const curr = doubleProposal ?? null;
    if (prev && !curr) {
      const multNow = Number(betMultiplier) || 1;
      const multAtOffer = multAtOfferRef.current ?? multNow;
      if (multNow === multAtOffer) playSfx('pass');
      multAtOfferRef.current = null;
    }
  }, [doubleProposal, betMultiplier]); // eslint-disable-line

  // ====== SFX: Winner / Loser один раз ======
  useEffect(() => {
    if (resultSfxPlayedRef.current) return;
    if (!longGameResult) return;
    if (!showLongResultModal) return;

    const me = localStorage.getItem('username') || '';
    const iWin = Boolean(me && longGameResult.winnerUsername && me === longGameResult.winnerUsername);

    playSfx(iWin ? 'winner' : 'loser');

    // мгновенно синхронизируем баланс победителя в шапке
    try {
      const me2 = localStorage.getItem('username') || '';
      if (me2 && longGameResult?.winnerUsername === me2) {
        const nextBalance = Number(longGameResult?.updatedWinnerBalance ?? NaN);
        if (Number.isFinite(nextBalance)) {
          window.dispatchEvent(
            new CustomEvent('balance-updated', { detail: { balance: nextBalance } })
          );
        }
      }
    } catch (_) {}

    resultSfxPlayedRef.current = true;
  }, [showLongResultModal, longGameResult]); // eslint-disable-line




useEffect(() => {
  const onSnap = (payload) => {
    if (!payload || payload.tableId !== tableId) return;
    setPeerOnline(payload.online || {});
  };
  const onPeer = ({ tableId: tId, player, online }) => {
    if (tId !== tableId || !player) return;
    setPeerOnline((prev) => ({ ...prev, [player]: !!online }));
  };
  longSocket.on('long_peerSnapshot', onSnap);
  longSocket.on('long_peerStatus', onPeer);
  return () => {
    longSocket.off('long_peerSnapshot', onSnap);
    longSocket.off('long_peerStatus', onPeer);
  };
}, [tableId]);

// вычисляем имя оппонента
const opponentName = useMemo(() => {
  const me = String(username || '').trim();
  const p1 = String(longPlayer1Name || '').trim();
  const p2 = String(longPlayer2Name || '').trim();
  if (!me) return p1 || p2 || null;
  if (me === p1) return p2 || null;
  if (me === p2) return p1 || null;
  // если нас ещё нет в паре, считаем оппонентом занятого слота (если есть)
  return p1 && p1 !== me ? p1 : (p2 && p2 !== me ? p2 : null);
}, [username, longPlayer1Name, longPlayer2Name]);

const opponentOffline = !!(conn.online && opponentName && peerOnline && peerOnline[opponentName] === false);

  // баннер про «оппонент потерял связь» тоже не нужен после конца игры/сдачи
const shouldShowPeerBanner =
  conn.online && opponentOffline && !suppressConnBannerByUi;

// useEffect(() => {
//   console.log('[AVA white]', whiteAvatarCandidates);
//   console.log('[AVA black]', blackAvatarCandidates);
// }, [whiteAvatarCandidates, blackAvatarCandidates]);
  // ====== SFX: "Good luck" (первый жест) ======
  useEffect(() => {
    const ready =
      Number.isInteger(longFirstRolls?.player1Roll) &&
      Number.isInteger(longFirstRolls?.player2Roll);

    if (!ready) return;
    if (goodluckPlayedRef.current) return;
    if (isSpectator) return;
    if (showLongResultModal) return;

    if (gestureHandlerRef.current) {
      window.removeEventListener('pointerdown', gestureHandlerRef.current);
      gestureHandlerRef.current = null;
    }

    const onFirstGesture = async () => {
      if (goodluckPlayedRef.current) return;
      try {
        const r = play?.('goodluck');
        if (r && typeof r.then === 'function') await r;
      } catch (_) {
      } finally {
        goodluckPlayedRef.current = true;
        suppressClickUntilRef.current = Date.now() + 250;
        window.removeEventListener('pointerdown', onFirstGesture);
        gestureHandlerRef.current = null;
      }
    };

    try {
      const maybe = play?.('goodluck');
      if (maybe && typeof maybe.then === 'function') {
        maybe.then(() => {
          goodluckPlayedRef.current = true;
          suppressClickUntilRef.current = Date.now() + 250;
        }).catch(() => {
          if (!goodluckPlayedRef.current) {
            gestureHandlerRef.current = onFirstGesture;
            window.addEventListener('pointerdown', onFirstGesture, { once: true, passive: true });
          }
        });
      } else {
        gestureHandlerRef.current = onFirstGesture;
        window.addEventListener('pointerdown', onFirstGesture, { once: true, passive: true });
      }
    } catch (_) {
      gestureHandlerRef.current = onFirstGesture;
      window.addEventListener('pointerdown', onFirstGesture, { once: true, passive: true });
    }

    return () => {
      if (gestureHandlerRef.current) {
        window.removeEventListener('pointerdown', gestureHandlerRef.current);
        gestureHandlerRef.current = null;
      }
    };
  }, [longFirstRolls, isSpectator, showLongResultModal, play]); // eslint-disable-line

  const longWhiteUi = {
    name: getDisplayName('white'),
    rating: Number.isFinite(Number(longPlayer1Rating)) ? longPlayer1Rating : '—',
    time: formatSec(p1TimeForRender),
  };

  const longBlackUi = {
    name: getDisplayName('black'),
    rating: Number.isFinite(Number(longPlayer2Rating)) ? longPlayer2Rating : '—',
    time: formatSec(p2TimeForRender),
  };

  const longMyUi = longMyColor === 'white' ? longWhiteUi : longBlackUi;
  const longOpponentUi = longMyColor === 'white' ? longBlackUi : longWhiteUi;

  const canUseLongPortal = typeof document !== 'undefined';
  const maybeLongPortal = (node) =>
    canUseLongPortal ? createPortal(node, document.body) : node;

  const longBoardSettingsDialog = showLongBoardSettings
    ? maybeLongPortal(
        <div
          className="long-v2-board-settings-overlay long-cash-isolated-settings-overlay"
          role="presentation"
          onMouseDown={(event) => {
            if (event.target === event.currentTarget) closeLongBoardSettings();
          }}
        >
          <section
            className="long-v2-board-settings-modal long-cash-isolated-settings-modal"
            role="dialog"
            aria-modal="true"
            aria-labelledby="long-v2-board-settings-title"
            onMouseDown={(event) => event.stopPropagation()}
          >
            <header className="long-v2-board-settings-header">
              <div>
                <p className="long-v2-board-settings-eyebrow">
                  {translate('game.short.boardTheme', { defaultValue: 'Тема доски' })}
                </p>
                <h2 id="long-v2-board-settings-title">
                  {translate('game.short.chooseBoard', { defaultValue: 'Выберите дизайн доски' })}
                </h2>
              </div>

              <button
                type="button"
                className="long-v2-board-settings-close"
                onClick={closeLongBoardSettings}
                aria-label={translate('game.common.close', { defaultValue: 'Закрыть' })}
              >
                <span aria-hidden="true">×</span>
              </button>
            </header>

            <div className="long-v2-board-skin-grid">
              {LONG_BOARD_SKIN_OPTIONS.map((option) => {
                const isSelected = longBoardSkin === option.id;
                const label = translate(option.labelKey, {
                  defaultValue: option.defaultLabel,
                });

                return (
                  <button
                    key={option.id}
                    type="button"
                    className={`long-v2-board-skin-card ${isSelected ? 'is-selected' : ''}`}
                    onClick={() => selectLongBoardSkin(option.id)}
                    aria-pressed={isSelected}
                  >
                    <span className="long-v2-board-skin-preview">
                      <img src={option.src} alt="" draggable="false" />
                      {isSelected && (
                        <span className="long-v2-board-skin-check" aria-hidden="true">
                          <LongCheckIcon />
                        </span>
                      )}
                    </span>
                    <span className="long-v2-board-skin-name">{label}</span>
                  </button>
                );
              })}
            </div>

            <p className="long-v2-board-settings-note">
              {translate('game.short.boardSavedAutomatically', {
                defaultValue: 'Выбранная доска сохранится на этом устройстве.',
              })}
            </p>
          </section>
        </div>
      )
    : null;

  const showLongV2QuickControls = Boolean(
    !showLongResultModal &&
    !longGameResult
  );

  const longPhonePortrait = Boolean(
    longV2Viewport.width <= 1100 &&
    longV2Viewport.height >= longV2Viewport.width
  );

  const longUseBoardLocalControls = Boolean(
    longPhonePortrait || longV2Viewport.phoneLandscape
  );

  const longV2QuickControls = showLongV2QuickControls && !longUseBoardLocalControls
    ? maybeLongPortal(
        <div
          className={`long-v2-control-dock long-cash-isolated-control-dock ${
            longV2Viewport.phoneLandscape ? 'long-v2-control-dock--landscape' : ''
          }`}
          role="group"
          aria-label={translate('game.short.quickSettings', {
            defaultValue: 'Быстрые настройки игры',
          })}
          onMouseDown={(event) => event.stopPropagation()}
          onTouchStart={(event) => event.stopPropagation()}
        >
          {!isSpectator && (
            <>
              <button
                type="button"
                className={`long-v2-control-btn ${autoRoll ? 'is-active' : ''}`}
                onClick={(event) => {
                  event.stopPropagation();
                  onToggleAutoRoll?.();
                }}
                disabled={typeof onToggleAutoRoll !== 'function'}
                aria-pressed={Boolean(autoRoll)}
                title={translate('game.common.autoRoll', { defaultValue: 'Автобросок' })}
              >
                <span className="long-v2-control-icon"><LongAutoRollIcon /></span>
                <span className="long-v2-control-text">
                  {translate('game.common.autoRoll', { defaultValue: 'Автобросок' })}
                </span>
                <span className="long-v2-control-indicator" aria-hidden="true" />
              </button>

              <button
                type="button"
                className={`long-v2-control-btn ${autoConfirm ? 'is-active' : ''}`}
                onClick={(event) => {
                  event.stopPropagation();
                  onToggleAutoConfirm?.();
                }}
                disabled={typeof onToggleAutoConfirm !== 'function'}
                aria-pressed={Boolean(autoConfirm)}
                title={translate('game.common.autoMove', { defaultValue: 'Автоход' })}
              >
                <span className="long-v2-control-icon"><LongAutoMoveIcon /></span>
                <span className="long-v2-control-text">
                  {translate('game.common.autoMove', { defaultValue: 'Автоход' })}
                </span>
                <span className="long-v2-control-indicator" aria-hidden="true" />
              </button>
            </>
          )}

          <button
            type="button"
            className="long-v2-control-btn long-v2-control-btn--settings"
            onClick={(event) => {
              event.stopPropagation();
              setShowLongBoardSettings(true);
            }}
            title={translate('game.short.boardSettings', {
              defaultValue: 'Выбрать дизайн доски',
            })}
          >
            <span className="long-v2-control-icon"><LongSettingsIcon /></span>
            <span className="long-v2-control-text">
              {translate('game.common.settings', { defaultValue: 'Настройки' })}
            </span>
          </button>
        </div>
      )
    : null;

  // На телефоне (portrait и landscape) панель рендерим ВНУТРИ доски.
  // Так она привязана к центральному бортику и кубу, а не к viewport.
  const longV2BoardQuickControls =
    showLongV2QuickControls && longUseBoardLocalControls
      ? (
        <div
          className={`long-v2-control-dock long-cash-isolated-control-dock long-cash-isolated-control-dock--board ${
            longV2Viewport.phoneLandscape
              ? 'long-cash-isolated-control-dock--board-landscape'
              : 'long-cash-isolated-control-dock--board-portrait'
          }`} 
          role="group"
          aria-label={translate('game.short.quickSettings', {
            defaultValue: 'Быстрые настройки игры',
          })}
          onMouseDown={(event) => event.stopPropagation()}
          onTouchStart={(event) => event.stopPropagation()}
        >
          {!isSpectator && (
            <>
              <button
                type="button"
                className={`long-v2-control-btn ${autoRoll ? 'is-active' : ''}`}
                onClick={(event) => {
                  event.stopPropagation();
                  onToggleAutoRoll?.();
                }}
                disabled={typeof onToggleAutoRoll !== 'function'}
                aria-pressed={Boolean(autoRoll)}
                title={translate('game.common.autoRoll', { defaultValue: 'Автобросок' })}
              >
                <span className="long-v2-control-icon"><LongAutoRollIcon /></span>
                <span className="long-v2-control-text">
                  {translate('game.common.autoRoll', { defaultValue: 'Автобросок' })}
                </span>
                <span className="long-v2-control-indicator" aria-hidden="true" />
              </button>

              <button
                type="button"
                className={`long-v2-control-btn ${autoConfirm ? 'is-active' : ''}`}
                onClick={(event) => {
                  event.stopPropagation();
                  onToggleAutoConfirm?.();
                }}
                disabled={typeof onToggleAutoConfirm !== 'function'}
                aria-pressed={Boolean(autoConfirm)}
                title={translate('game.common.autoMove', { defaultValue: 'Автоход' })}
              >
                <span className="long-v2-control-icon"><LongAutoMoveIcon /></span>
                <span className="long-v2-control-text">
                  {translate('game.common.autoMove', { defaultValue: 'Автоход' })}
                </span>
                <span className="long-v2-control-indicator" aria-hidden="true" />
              </button>
            </>
          )}

          <button
            type="button"
            className="long-v2-control-btn long-v2-control-btn--settings"
            onClick={(event) => {
              event.stopPropagation();
              setShowLongBoardSettings(true);
            }}
            title={translate('game.short.boardSettings', {
              defaultValue: 'Выбрать дизайн доски',
            })}
          >
            <span className="long-v2-control-icon"><LongSettingsIcon /></span>
            <span className="long-v2-control-text">
              {translate('game.common.settings', { defaultValue: 'Настройки' })}
            </span>
          </button>
        </div>
        )
      : null;


  // ====== Рендер ======
  const khachapuriTotalGames = Math.max(1, Number(longTargetPoints) || 1);
const khachapuriGameNo = Math.max(
  1,
  Math.min(khachapuriTotalGames, Number(khachapuriCurrentGame) || 1)
);

return (
    <>
      <DoublingModal />
      {longBoardSettingsDialog}
      {longV2QuickControls}

      {/* ⬇️ БАННЕР СОСТОЯНИЯ СЕТИ */}
{shouldShowConnBanner && (
  <div
    className={`conn-banner ${conn.reconnecting ? 'reconnecting' : 'offline'}`}
    role="status"
    aria-live="polite"
   
  >
    <span>
      {conn.reconnecting
        ? translate('game.common.reconnectingAttempt', { attempt: conn.attempt || 1 })
        : translate('game.common.noConnection')}
      {conn.message ? ` — ${conn.message}` : ''}
    </span>
    <button
      type="button"
      onClick={ensureLongSocketAuthAndConnect}
      style={{ background: 'rgba(255,255,255,0.2)', color: '#fff', border: 'none', padding: '6px 10px', borderRadius: 6, cursor: 'pointer' }}
    >
      {translate('game.common.reconnectNow')}
    </button>
  </div>
)}
{/* ⬆️ БАННЕР */}



           <div
        className={`long-cash long-cash-v2 long-cash-isolated ${
          longV2Viewport.phoneLandscape ? 'long-cash-v2--phone-landscape' : ''
        }`}
        style={{
          '--long-v2-scale': longBoardScale,
          '--long-v2-board-width': `${1020 * longBoardScale}px`,
          '--long-v2-board-height': `${760 * longBoardScale}px`,
        }}
      >

<div className="table-actions">
  {isSpectator ? (
    // 👁 ЗРИТЕЛЬ — ТОЛЬКО ВЫЙТИ
    <button
      className="btn btn--leave"
      onClick={() => {
        clearLongLocals();     // чистим локальные данные
        longLeaveTable?.();    // выходим в лобби
      }}
    >
      <span className="btn-ico">🚪</span>
      {translate('game.common.exit')}
    </button>
  ) : (bothPlayersSeated && longStarted) ? (
    // ♟ ИГРОК — ИГРА НАЧАЛАСЬ → МОЖНО СДАТЬСЯ
    <button
      className="btn btn--resign"
      onClick={onSurrenderClick}
    >
      <span className="btn-ico">🏳️</span>
      {translate('game.common.surrender')}
    </button>
  ) : (
    // ♟ ИГРОК — ИГРА ЕЩЁ НЕ НАЧАЛАСЬ → ВЫЙТИ
    <button
      className="btn btn--leave"
      onClick={() => {
        clearLongLocals();
        longLeaveTable?.();
      }}
    >
      <span className="btn-ico">🚪</span>
      {translate('game.common.exit')}
    </button>
  )}
</div>



{mobileGhost && (
  <div
    className={`checker checker-ghost ${mobileGhost.color}${longBoardGhostClass}`}
    style={{ left: mobileGhost.x, top: mobileGhost.y }}
  />
)}

{/* === ПК HUD СЛЕВА ОТ ДОСКИ — как в коротких кеш-нардах === */}
<div className="long-v2-desktop-side-hud">
  <div className="long-v2-desktop-player long-v2-desktop-player--opponent">
    <Avatar
      src={(longMyColor === 'white' ? blackAvatarCandidates : whiteAvatarCandidates)[0]}
      srcList={(longMyColor === 'white' ? blackAvatarCandidates : whiteAvatarCandidates).slice(1)}
      alt={longOpponentUi.name}
      size={100}
      textFallback="BQ"
      className="long-v2-desktop-avatar"
    />
    <div className="long-v2-desktop-player-meta">
      <div className="long-v2-desktop-name">{longOpponentUi.name}</div>
      <div className="long-v2-desktop-elo">ELO {longOpponentUi.rating}</div>
      <div className="long-v2-desktop-time">{longOpponentUi.time}</div>
    </div>
  </div>

  <div className="long-v2-desktop-center">
    <div className="long-v2-desktop-score">
      <span>{longMatchScore?.[0] ?? 0}</span>
      <b>:</b>
      <span>{longMatchScore?.[1] ?? 0}</span>
    </div>
    <div className="long-v2-desktop-stake">
      {translate('game.short.stake')} {money(uiMoneyStake)}
    </div>
    <div className="long-v2-desktop-match">
      Партия {khachapuriGameNo}/{khachapuriTotalGames}
    </div>
  </div>

  <div className="long-v2-desktop-player long-v2-desktop-player--me">
    <div className="long-v2-desktop-player-meta long-v2-desktop-player-meta--right">
      <div className="long-v2-desktop-name">{longMyUi.name}</div>
      <div className="long-v2-desktop-elo">ELO {longMyUi.rating}</div>
      <div className="long-v2-desktop-time">{longMyUi.time}</div>
    </div>
    <Avatar
      src={(longMyColor === 'white' ? whiteAvatarCandidates : blackAvatarCandidates)[0]}
      srcList={(longMyColor === 'white' ? whiteAvatarCandidates : blackAvatarCandidates).slice(1)}
      alt={longMyUi.name}
      size={100}
      textFallback="BQ"
      className="long-v2-desktop-avatar"
    />
  </div>
</div>

<div className="top-center-block">
        {/* Компактный центр-HUD */}
        {/* <div className="stake-hud stake-hud--compact">
     

          <div className="stake-pill">
            <span className="pill-label">Ставка</span>
            <span className="pill-value">{money(uiMoneyStake)}</span>
          </div>

          <div className="stake-pill">
            <span className="pill-label">Матч</span>
            <span className="pill-value">
              {(longMatchScore?.[0] ?? 0)}
              <span className="dot">–</span>
              {(longMatchScore?.[1] ?? 0)}
              <span className="slash"> / </span>
              {longTargetPoints ?? '—'}
            </span>
          </div>
        </div> */}
      
  {/* === ПАНЕЛЬ ИГРОКОВ НАД ДОСКОЙ (ПК) === */}
<div className="long-header long-v2-header long-cash-isolated-header">

  {/* ЛЕВЫЙ ИГРОК */}
  <div className="lh-player">
  <Avatar
  src={whiteAvatarCandidates[0]}
  srcList={whiteAvatarCandidates.slice(1)}
  alt={translate('game.common.white')}
  size={60}
/>


    <div className="lh-text">
      <div className="lh-name">
  {getDisplayName('white')}
</div>

      <div className="lh-row">
       <span className="lh-elo">
  ELO {Number.isFinite(Number(longPlayer1Rating)) ? longPlayer1Rating : '—'}
</span>

       <span className="lh-time">
  ⏱ {formatSec(p1TimeForRender)}
</span>

      </div>
    </div>
  </div>

  {/* ЦЕНТР */}
  <div className="lh-center">
  <div className="lh-score">
  <span className="score-num">
    {longMatchScore?.[0] ?? 0}
  </span>

  <span className="score-sep">:</span>

  <span className="score-num">
    {longMatchScore?.[1] ?? 0}
  </span>
</div>


  <div className="lh-stake">
  {translate('game.short.stake')} <strong>{money(uiMoneyStake)}</strong>
</div>


<div className="lh-match">
  Партия {khachapuriGameNo}/{khachapuriTotalGames}
</div>


  </div>

  {/* ПРАВЫЙ ИГРОК */}
  <div className="lh-player lh-player--right">
    <div className="lh-text">
      <div className="lh-name">
  {getDisplayName('black')}
</div>
      <div className="lh-row">
       <span className="lh-elo">
  ELO {Number.isFinite(Number(longPlayer2Rating)) ? longPlayer2Rating : '—'}
</span>

        <span className="lh-time">
  ⏱ {formatSec(p2TimeForRender)}
</span>

      </div>
    </div>

   <Avatar
  src={blackAvatarCandidates[0]}
  srcList={blackAvatarCandidates.slice(1)}
  alt={translate('game.common.black')}
  size={60}
/>

  </div>

</div>



  </div>

        {/* Мобильные карточки игроков под счётом (авы + ELO + время) */}
       

<div className="long-board-and-auto long-v2-stage long-cash-isolated-stage">

        <div className="board-wrapper long-board-wrapper long-v2-board-wrapper long-cash-isolated-wrapper">

          {/* Боковые панели с аватарками */}
          {/* <div className={`player-rail rail-left ${isP1Turn ? 'rail--active' : ''}`}>
          <Avatar
            src={whiteAvatarCandidates[0]}
            srcList={whiteAvatarCandidates.slice(1)}
            alt="Белые"
            textFallback="BQ"
          />
            <div className="rail-name">{getDisplayName('white')}</div>

            <div className="rail-lines">
              <div className="rail-line rail-elo" title="Рейтинг">
             
                <span className="rail-text">
                  {Number.isFinite(Number(longPlayer1Rating)) ? Number(longPlayer1Rating) : '—'}
                </span>
              </div>
              <div className={`rail-line rail-time ${isP1Turn ? 'is-active' : ''}`} title="Оставшееся время">
                <span className="rail-ico">⏱</span>
                <span className="rail-text">{formatSec(longPlayer1Time)}</span>
              </div>
            </div>
          </div> */}
{/* ЛЕВАЯ КАРТОЧКА (Белые) */}
{/* Боковые панели с аватарками */}
{/*  */}


        {/* Мой обрыв */}
{/* {!conn.online && ( */}
{shouldShowConnBanner &&  (
  <div className="long-conn-banner long-conn-banner--self">
    <strong>{translate('game.common.noServerConnection')}</strong>
    <span> {translate('game.common.tryingReconnect')}</span>
    {conn.reconnecting && typeof conn.attempt === 'number' && (
      <span> {translate('game.common.attemptNumber')}{conn.attempt}</span>
    )}
    {conn.message && <span className="muted"> ({conn.message})</span>}
  </div>
)}

{/* Оппонент потерял связь */}
{/* {conn.online && opponentOffline && ( */}
{shouldShowPeerBanner &&  (
  <div className="long-conn-banner long-conn-banner--peer">
    <strong>{opponentName}</strong> {translate('game.long.opponentDisconnected')}
  </div>
)}


 <div
  className={`board long-board long-board-v2 long-cash-isolated-board khachapuri-board long-board-skin-${longBoardSkin}`}
  onPointerUp={handleBoardPointerUp}
  onPointerMove={handleBoardPointerMove}
  onPointerCancel={handleBoardPointerCancel}
>



            <img className="long-board-bg" src={longBoardImageSrc} alt={longBoardImageAlt} draggable="false" />
{/* === КУБ УДВОЕНИЯ: на desktop только ОДИН center-куб === */}
{!showLongResultModal && !isLongMobile && renderKhachapuriDoublingCube(false)}

{longV2BoardQuickControls}


{longV2Viewport.phoneLandscape && (
  <div className="long-v2-landscape-hud long-v2-landscape-hud--board">
    <div className="long-v2-landscape-player long-v2-landscape-player--top">
      <Avatar
        src={(longMyColor === 'white' ? blackAvatarCandidates : whiteAvatarCandidates)[0]}
        srcList={(longMyColor === 'white' ? blackAvatarCandidates : whiteAvatarCandidates).slice(1)}
        alt={longOpponentUi.name}
        size={24}
        textFallback="BQ"
        className="long-v2-landscape-avatar"
      />
      <div className="long-v2-landscape-name">{longOpponentUi.name}</div>
      <div className="long-v2-landscape-elo">ELO {longOpponentUi.rating}</div>
      <div className="long-v2-landscape-time">{longOpponentUi.time}</div>
    </div>

    <div className="long-v2-landscape-player long-v2-landscape-player--bottom">
      <Avatar
        src={(longMyColor === 'white' ? whiteAvatarCandidates : blackAvatarCandidates)[0]}
        srcList={(longMyColor === 'white' ? whiteAvatarCandidates : blackAvatarCandidates).slice(1)}
        alt={longMyUi.name}
        size={24}
        textFallback="BQ"
        className="long-v2-landscape-avatar"
      />
      <div className="long-v2-landscape-name">{longMyUi.name}</div>
      <div className="long-v2-landscape-elo">ELO {longMyUi.rating}</div>
      <div className="long-v2-landscape-time">{longMyUi.time}</div>
    </div>
  </div>
)}


            {/* Первый бросок (до начала игры) */}
            {longFirstRolls && (
              <div className="first-rolls-display">
                {Number.isInteger(longFirstRolls?.player1Roll) && (
                  <img
                    src={diceImages.white[longFirstRolls.player1Roll]}
                    alt={translate('game.common.firstRollPlayer1', { value: longFirstRolls.player1Roll })}
                    className="dice-image first-roll-player1"
                  />
                )}
                {Number.isInteger(longFirstRolls?.player2Roll) && (
                  <img
                    src={diceImages.black[longFirstRolls.player2Roll]}
                    alt={translate('game.common.firstRollPlayer2', { value: longFirstRolls.player2Roll })}
                    className="dice-image first-roll-player2"
                  />
                )}
              </div>
            )}

            {/* Кнопка "Бросить кубики" */}
            {isMyTurn
              && !longHasRolledDice
              && longFirstMoveComplete
              && !isSpectator
              && !waitingDoubleReply
              && !doubleProposal && (
                <button
                  type="button"
                  className="roll-dice-button"
                  onClick={handleLongRollDiceClickSfx}
                  onPointerDown={stopMobileActionPointer}
                  onPointerUp={stopMobileActionPointer}
                  onTouchEnd={runMobileTap(handleLongRollDiceClickSfx)}
                >
                  {translate('game.common.rollDice')}
                </button>
            )}

            {/* Кубики хода */}
            {/* {Array.isArray(longRolledDice) && longRolledDice.length > 0 && (
              <div className="dice-display">
                {longRolledDice.map((val, idx) => {
                  const diceColor = rolledByPlayer === 'player1' ? 'white' : 'black';
                  return (
                    <img key={idx} src={diceImages[diceColor]?.[val]} alt={`Dice ${val}`} />
                  );
                })}
              </div>
            )} */}
{Array.isArray(longRolledDice) && longRolledDice.length > 0 && (
  <div className="dice-display">
    {longRolledDice.map((val, idx) => {
      // это "особый" случай: первый ход, который идёт из стартового броска
      const isFirstTurnFromInitialRoll =
        !!longFirstRolls &&            // у нас есть стартовый бросок
        !longFirstMoveComplete &&      // первый ход ещё не завершён
        Array.isArray(longRolledDice) &&
        longRolledDice.length === 2;   // классическая пара кубиков

      let diceColor;

      if (isFirstTurnFromInitialRoll) {
        // 👉 здесь как раз делаем один белый + один чёрный
        // idx === 0 → белый, idx === 1 → чёрный
        diceColor = idx === 0 ? 'white' : 'black';
      // } else {
      //   // все остальные ходы: оба кубика цвета игрока, который бросал
      //   if (rolledByPlayer === 'player1') {
      //     diceColor = 'white';
      //   } else if (rolledByPlayer === 'player2') {
      //     diceColor = 'black';
      //   } else {
      //     // запасной вариант, если rolledByPlayer вдруг не пришёл
      //     diceColor = longCurrentTurn === 'player1' ? 'white' : 'black';
      //   }
      // }
      } else {
        // все остальные ходы

        // 1) пробуем взять цвет из текущего хода (главный источник)
        const turnOwner =
          longCurrentTurn === 'player1' || longCurrentTurn === 'player2'
            ? longCurrentTurn
            : null;

        // 2) если вдруг longCurrentTurn нет — пробуем rolledByPlayer
        const rollOwner =
          rolledByPlayer === 'player1' || rolledByPlayer === 'player2'
            ? rolledByPlayer
            : null;

        // 3) кто в итоге считается владельцем броска
        const owner = turnOwner || rollOwner;

        diceColor = owner === 'player1' ? 'white' : 'black';
      }

      return (
        <img
          key={idx}
          src={diceImages[diceColor]?.[val]}
          alt={`Dice ${val}`}
        />
      );
    })}
  </div>
)}

            {/* Отмена хода */}
            {longShowUndoButton && !isSpectator &&(
              <button
                type="button"
                className="undo-button"
                onClick={longHandleUndoMoveSfx}
                onPointerDown={stopMobileActionPointer}
                onPointerUp={stopMobileActionPointer}
                onTouchEnd={runMobileTap(longHandleUndoMoveSfx)}
              >
                {translate('game.common.cancel')}
              </button>
            )}

            {/* Завершить ход */}
            { longCurrentTurn === (longMyColor==='white'?'player1':'player2')
              && longNumberMove===0
              && longHasRolledDice
              && !doubleProposal
              && !waitingDoubleReply
              && !doubleJustTaken
              && !isSpectator && (
                <button
                  type="button"
                  className="long-ok-button"
                  onClick={longConfirmMoveSfx}
                  onPointerDown={stopMobileActionPointer}
                  onPointerUp={stopMobileActionPointer}
                  onTouchEnd={runMobileTap(longConfirmMoveSfx)}
                >
                  <img src="/img/Ok.png" alt={translate('game.common.finishMove')} />
                </button>
            )}

            {/* Ряды фишек */}
            {longMyColor === 'white' ? (
              <>
                {renderWhiteTopRow()}
                {renderWhiteBottomRow()}
              </>
            ) : (
              <>
                {renderBlackTopRow()}
                {renderBlackBottomRow()}
              </>
            )}

            {/* бар и офф-борд */}
            <div className="bar" />

            <div className="off-board">
              {isSpectator ? (
                <>
                  <div className="off-board-opponentLong">
                    {showWhiteOff}
                  </div>
                  <div className="off-board-myLong">
                    {showBlackOff}
                  </div>
                </>
              ) : (
                <>
                  <div className="off-board-opponentLong">
                    {showOppOff}
                  </div>
                  <div className="off-board-myLong">
                    {showMyOff}
                  </div>
                </>
              )}
            </div>

            {/* Результат игры — красивая модалка */}
            {showLongResultModal && longGameResult && (
              <div className="result-modal-overlay" role="dialog" aria-modal="true">
                <div className="result-modal">
                  <div className="rm-header">
                    <h2>{translate('game.common.gameFinished')}</h2>
                    <button className="rm-close" onClick={onResultClose} aria-label={translate('game.common.close')}>✕</button>
                  </div>

                  <div className="rm-body">
                    <div className="rm-card winner">
                      <div className="rm-badge">{translate('game.common.winner')}</div>
                    {/* Победитель */}
                    {/* <Avatar
                      src={winnerAvatarCandidates[0]}
                      srcList={winnerAvatarCandidates.slice(1)}
                      alt={longGameResult.winnerUsername || 'Победитель'}
                      size={96}
                      className="rm-avatar"
                      textFallback="BQ"
                    /> */}
                    {/* Победитель */}
{/* <img
  src={winnerModalSrcRef.current || '/img/placeholder.png'}
  alt={longGameResult.winnerUsername || 'Победитель'}
  width={96}
  height={96}
  className="rm-avatar"
  style={{ width: 96, height: 96, objectFit: 'cover' }}
  decoding="async"
  loading="eager"
/> */}
<Avatar
  src={modalAvatars.winner}
  alt={longGameResult.winnerUsername || translate('game.common.winner')}
  size={96}
  className="rm-avatar"
  textFallback="BQ"
/>


                     <div className="rm-name">{longGameResult.winnerUsername}</div>

                      <div className="rm-stats">
                        <div className="rm-row">
                          <span className="rm-label">{translate('game.long.balanceBefore')}</span>
                          <span className="rm-value">${longGameResult.initialWinnerBalance}</span>
                        </div>
                        <div className="rm-row">
                          <span className="rm-label">{translate('game.long.balanceAfter')}</span>
                          <span className="rm-value">${longGameResult.updatedWinnerBalance}</span>
                        </div>
                        <div className="rm-row rm-row--gain">
                          <span className="rm-label">{translate('game.long.won')}</span>
                          <span className="rm-value">+${longGameResult.winnerAmount}</span>
                        </div>


                        {/* === Автонастройки под доской === */}



                      </div>
                    </div>

                    <div className="rm-card loser">
                      <div className="rm-badge rm-badge--secondary">{translate('game.common.loser')}</div>
                 {/* Проигравший */}
                    {/* <Avatar
                      src={loserAvatarCandidates[0]}
                      srcList={loserAvatarCandidates.slice(1)}
                      alt={longGameResult.loserUsername || 'Проигравший'}
                      size={96}
                      className="rm-avatar"
                      textFallback="BQ"
                    /> */}
                    {/* Победитель */}
{/* <img
  src={loserModalSrcRef.current || '/img/placeholder.png'}
  alt={longGameResult.loserUsername || 'Проигравший'}
  width={96}
  height={96}
  className="rm-avatar"
  style={{ width: 96, height: 96, objectFit: 'cover' }}
  decoding="async"
  loading="eager"
/> */}
<Avatar
  src={modalAvatars.loser}
  alt={longGameResult.loserUsername || translate('game.common.loser')}
  size={96}
  className="rm-avatar"
  textFallback="BQ"
/>
              <div className="rm-name">{longGameResult.loserUsername}</div>

                      <div className="rm-stats">
                        <div className="rm-row">
                          <span className="rm-label">{translate('game.long.balanceBefore')}</span>
                          <span className="rm-value">${longGameResult.initialLoserBalance}</span>
                        </div>
                        <div className="rm-row">
                          <span className="rm-label">{translate('game.long.balanceAfter')}</span>
                          <span className="rm-value">${longGameResult.updatedLoserBalance}</span>
                        </div>
                        <div className="rm-row rm-row--loss">
                          <span className="rm-label">{translate('game.long.lost')}</span>
                          <span className="rm-value">-${longGameResult.finalStake}</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="rm-footer">
                    {/* <button className="btn btn--primary" onClick={onResultClose}>Ок</button> */}
                    {/* <button
  className="btn btn--primary"
  onClick={() => {
    try {
      if (SNAP_KEY) localStorage.removeItem(SNAP_KEY);
    } catch (e) {}

    try {
      clearLongRoom();
    } catch (e) {}

    onResultClose?.();
  }}
>
  Ок
</button> */}
<button
  className="btn btn--primary"
  onClick={() => {
    clearLongLocals();   // чистим и room, и снап, и current
    onResultClose?.();   // дальше уже пусть родитель уводит куда нужно
  }}
>
  {translate('game.common.ok')}
</button>
                  </div>
                </div>
              </div>

              
            )}
            {/* Мобильный куб: единственный экземпляр, без перекрытия center-кубом */}
            {!showLongResultModal && isLongMobile && renderKhachapuriDoublingCube(true)}

            
          </div>

       
         {/* Дублирующий куб — скрываем, когда открыта модалка результата */}
          {/* Куб под доской — только для ПК */}
              {/* {!showLongResultModal && !isLongMobile && (
            <div
              className={
                `doubling-cube ${cubePositionClass()} ` +
                `${cubeDisabled ? 'disabled' : ''} ` +
                `${isCrawfordGame ? 'crawford' : ''}`
              }
              onClick={cubeDisabled ? undefined : onProposeDoubleClick}
              title={isCrawfordGame ? translate('game.long.crawfordNoDouble') : ''}
            >
              {renderLongCubeImage()}
            </div>
          )} */}

          {/* Простая модалка удвоения (второй вариант) */}
          {/* ...если она у тебя будет, то ниже... */}

        </div> {/* <-- ЗАКРЫЛИ .board-wrapper */}

        {/* Автонастройки под доской (ОДИНСТВЕННЫЙ блок) */}
        {/* Long V2: старый блок auto-actions заменён компактной панелью быстрых настроек. */}
</div> {/* <-- ЗАКРЫЛИ .long-board-and-auto */}

    </div>   {/* <-- ЗАКРЫЛИ .long-cash */}
  </>



  );
};

export default KhachapuriBoardDisplay;





